export default {
    greeting: 'Bonjour',
    submit: 'Soumettre',
    settings: {
        title: 'Paramètres',
        schedules: 'Horaires',
        merchantSchedules: 'Squelette 5@8',
        roadSchedules: 'Squelette terrain',
        schedulePlanning: 'Planification des horaires',
        scheduleLogs: 'Logs de connexion',
        drivers: 'Liste de livreurs',
        driverLocationsHistory: 'historique des déplacements des livreurs',
        driverIncidents: 'Incidents des chauffeurs',
        parameters: 'Paramètres',
        deliveryServiceSettings: 'Paramètres du service de livraison',
        autoDispatchSettings: 'Paramètres de l\'auto-dispatch',
        printNode: 'Imprimantes PrintNode',
        promoCodes: 'Codes promo',
        users: 'Utilisateurs',
        zones: 'Zones',
        deliveryZones: 'Zones de livraison (destinations)',
        externalShipments: 'Expéditions tiers',
        myAccount: 'Mon compte',
        integrations: 'Intégrations e-commerce',
        changePassword: 'Modifier le mot de passe',
        logout: 'Se déconnecter',
        printnode: {
            title: 'Imprimantes PrintNode',
            setup: 'Connectez-vous à distance à l\'ordinateur du commerce, installez le client PrintNode et ouvrez une session avec le compte PrintNode GoLivro. Actualisez cette page, associez l\'imprimante au commerce, puis envoyez une page test.',
            download: 'Télécharger le client PrintNode',
            refresh: 'Actualiser',
            notConfigured: 'La clé API PrintNode n\'est pas configurée sur le serveur.',
            syncError: 'Impossible de joindre PrintNode. Dernier état connu affiché.',
            account: 'Compte',
            credits: 'Crédits',
            computers: 'Ordinateurs',
            prints: 'Impressions',
            connected: 'Connecté',
            disconnected: 'Déconnecté',
            hostname: 'Ordinateur',
            version: 'Version',
            lastUpdate: 'Dernière mise à jour',
            printer: 'Imprimante',
            merchant: 'Commerce',
            unassigned: 'Non assignée',
            enabled: 'Impression auto',
            testPrint: 'Page test',
            noComputers: 'Aucun ordinateur PrintNode ne s\'est encore connecté.',
            jobs: 'Impressions récentes',
            order: 'Commande',
            test: 'Test',
            state: 'État',
            error: 'Erreur',
            emptyJobs: 'Aucune impression pour le moment.',
            forbidden: 'Cette page est réservée aux répartiteurs et aux administrateurs.',
            loading: 'Chargement…',
            saved: 'Enregistré',
            testSent: 'Page test envoyée.',
        },
    },
    volumeEstimate: {
        title: 'Estimation volume',
        subtitle: 'À partir d’un petit colis, une pièce par destination.',
        origin: 'Adresse de cueillette',
        originPlaceholder: 'Adresse du commerce (laissée vide si un commerce est sélectionné)',
        hubPackages: 'Colis Obibox / jour',
        flexPackages: 'Colis flexibles / jour',
        localPackages: 'Colis locaux / jour',
        quebecOntarioPackages: 'Colis Québec / Ontario / jour',
        nationwidePackages: 'Colis pan-canadiens / jour',
        visitsPerDay: 'Visites de ramassage / jour',
        workingDays: 'Jours ouvrables / semaine',
        avgObibox: 'Dernier mille Obibox moyen ($)',
        avgFlexKm: 'Distance flexible moyenne (km)',
        avgLar: 'Cote LAR moyenne ($)',
        targetMargin: 'Marge cible (%)',
        larMarkup: 'Marge LAR (%)',
        firstMileFloor: 'Plancher premier mille ($)',
        flexDiscountMode: 'Rabais flexible',
        modeStopCredit: 'Crédit d’arrêt partagé',
        modePlannedRate: 'Tarif planifié',
        postalCodes: 'Codes postaux échantillon (optionnel)',
        useHistory: 'Utiliser les destinations récentes du commerce',
        calculate: 'Calculer',
        error: 'Impossible de calculer l’estimation.',
        startingFrom: 'À partir de',
        startingFromCaption: 'Prix unitaires (petit colis, 1 par destination)',
        localTitle: 'Livraisons locales',
        localHint: 'Service flexible interne',
        quebecOntarioTitle: 'Québec / Ontario',
        quebecOntarioHint: 'Premier mille + Obibox',
        nationwideTitle: 'Pan-canadien',
        nationwideHint: 'Revente Livraison à rabais. Le volume ne baisse pas ce tarif; seule la marge LAR le change.',
        recommendedFees: 'Tarifs recommandés (à copier dans la fiche)',
        firstMileFee: 'Premier mille',
        flexUnitPrice: 'Prix flexible unitaire',
        copyFees: 'Copier les tarifs',
        copied: 'Copié',
        breakEven: 'Volume plancher (colis / visite)',
        detailsTitle: 'Détail des coûts',
        column: 'Scénario',
        daily: 'Par jour',
        weekly: 'Par semaine',
        monthly: 'Par mois',
        alaCarte: 'À la carte',
        opsCost: 'Notre coût',
        recommended: 'Prix recommandé',
        halfVolume: 'Si le volume est à 50 %',
        volumeBands: 'Premier mille selon le volume par ramassage',
        packagesPerVisit: 'Colis / visite',
        weeklyAlaCarte: 'Semaine à la carte',
        weeklyRecommended: 'Semaine recommandé',
        warnings: {
            hub_km_unavailable: 'Distance commerce → hub indisponible : le premier mille de base est utilisé.',
            merchant_history_empty: 'Aucune destination récente trouvée pour ce commerce.',
            obibox_sample_failed: 'Les cotes Obibox échantillon n’ont pas abouti.',
            flex_sample_failed: 'Les cotes flexibles échantillon n’ont pas abouti.',
            obibox_last_mile_missing: 'Indiquez un dernier mille Obibox moyen ou des codes postaux.',
            flex_last_mile_missing: 'Indiquez une distance flexible moyenne ou des codes postaux.',
            lar_not_configured: 'Livraison à rabais n’est pas configuré.',
            lar_origin_postal_missing: 'Code postal d’origine requis pour coter le pan-canadien.',
            lar_sample_failed: 'Les cotes Livraison à rabais n’ont pas abouti.',
        },
    },
    changeLanguage: 'Changer la langue',
    orderLegs: {
        sectionTitle: 'Livraisons',
        addLegTitle: 'Ajouter une étape',
        cancelForm: 'Annuler',
        legType: 'Type d\'étape',
        typeDelivery: 'Livraison interne',
        typeExternal: 'Expédition tierce',
        deliveryHint: 'Crée une nouvelle livraison entre les adresses de cueillette et de destination ci-dessous.',
        externalHint: 'Cote et crée une expédition transporteur entre les adresses de cueillette et de destination ci-dessous.',
        pickupTitle: 'Cueillette',
        destinationTitle: 'Destination',
        fieldName: 'Nom',
        fieldPhone: 'Téléphone',
        fieldStreet: 'Adresse',
        fieldCity: 'Ville',
        fieldPostalCode: 'Code postal',
        fieldLatitude: 'Latitude',
        fieldLongitude: 'Longitude',
        pickupAddressRequired: 'Veuillez compléter l\'adresse de cueillette (rue, ville, code postal).',
        destinationAddressRequired: 'Veuillez compléter l\'adresse de destination (rue, ville, code postal).',
        addDeliveryCta: 'Ajouter la livraison',
        addExternalCta: 'Créer l\'expédition tierce',
        getQuotes: 'Obtenir les cotations',
        editDimensions: 'Modifier les dimensions',
        dimensionsIntro: 'Dimensions requises pour coter les transporteurs.',
        dimensionsRequired: 'Veuillez saisir toutes les dimensions du colis.',
        quoteFailed: 'Impossible d\'obtenir les cotations transporteur.',
        selectCarrier: 'Sélectionnez un transporteur.',
        deliveryFailed: 'Impossible d\'ajouter la livraison.',
        externalFailed: 'Impossible de créer l\'expédition tierce.',
        externalTag: 'Tiers',
        colSequence: 'Séquence',
        colDestination: 'Destination',
        colStatus: 'Statut',
        colDriver: 'Livreur',
        colRoute: 'Route',
        colDriverPay: '$ Livreur',
        colDate: 'Date',
        colDelay: 'Délais',
        colAssigned: 'Assigné',
        colArrived: 'Arrivé',
        colRecovered: 'Récupéré',
        colEnRoute: 'En route',
        colCompleted: 'Complété',
        deliveryDetail: 'Livraison {seq}',
        colPod: 'POD',
        viewPod: 'Voir la POD',
        colActions: 'Actions',
        reunitePickupDelivery: 'Réunir le ramassage/livraison',
        editLeg: 'Modifier',
        colTimeline: 'Étapes',
        viewTimeline: 'Horaires',
        timelinePickup: 'Ramassage',
        timelineDeliverBefore: 'Livraison avant',
    },
    merchantExternalShipment: {
        modifyShipment: 'Modifier l\'expédition',
        useEditShipmentAction: 'Les commandes transporteur tiers sont toujours « Déjà payé ». Utilisez « Modifier l\'expédition » pour changer les adresses ou commentaires.',
        thirdPartyNoModifyHint: 'Les commandes transporteur tiers sont toujours « Déjà payé » et ne peuvent pas être modifiées ici. Contactez le support si vous avez besoin d\'aide.',
        editBlockedTitle: 'Modification d\'expédition impossible',
        editBlockedPickedUp: 'Le ramassage a déjà eu lieu — l\'étiquette ne peut plus être modifiée.',
        editBlockedDelivered: 'Cette commande est déjà livrée.',
        editBlockedCanceled: 'Cette expédition a été annulée.',
        editBlockedUnsupportedCarrier: 'Ce transporteur ne permet pas la modification en ligne pour le moment.',
        editBlockedGeneric: 'Cette expédition ne peut plus être modifiée en ligne. Contactez le support si vous avez besoin d\'aide.',
    },
    externalShipments: {
        orderId: 'Commande',
        merchant: 'Marchand',
        destination: 'Destination',
        carrier: 'Transporteur',
        service: 'Service',
        dimensions: 'Dimensions demandées',
        packages: 'colis',
        tracking: 'Suivi',
        status: 'Statut',
        lastUpdate: 'Dernière MAJ',
        createdAt: 'Créé le',
        colRevenue: 'Revenu',
        colCost: 'Coût transporteur',
        costTotal: 'Total',
        description: 'Liste des expéditions gérées par des transporteurs tiers',
        refresh: 'Actualiser',
        empty: 'Aucune expédition tier pour le moment.',
        noLabel: 'Étiquette non disponible.',
        labelError: 'Impossible d\'imprimer l\'étiquette: ',
        cancelConfirm: 'Annuler cette expédition tier ?',
        cancelSuccess: 'Expédition annulée.',
        cancelError: 'Annulation impossible: ',
        pickupSuccess: 'Ramassage planifié : la demande sera traitée dans environ 2 minutes.',
        pickupError: 'Demande de ramassage impossible: ',
        cancelPickupConfirm:
            'Annuler le ramassage planifié sur le portail ? Le portail transporteur sera mis à jour dans environ 2 minutes.',
        cancelPickupSuccess: 'Annulation de ramassage mise en file : traitement dans environ 2 minutes.',
        cancelPickupError: 'Annulation du ramassage impossible : ',
        pickupModalTitle: 'Planifier le ramassage (LAR)',
        pickupModalHint:
            'Créneaux d’une heure entre 8 h et 17 h ; l’heure « au plus tard » doit être au moins 4 h après le début.',
        pickupModalHintDateOnly:
            'Ce transporteur ne demande qu’une date de ramassage sur le portail Livraison à rabais (pas de plage horaire).',
        pickupWeekdaysOnlyHint:
            'Ramassage en semaine seulement (lun.–ven.) — les transporteurs tiers ramassent habituellement pas la fin de semaine.',
        pickupWeekdayOnlyError: 'Choisissez un jour ouvrable (lundi au vendredi).',
        pickupDate: 'Date de ramassage',
        pickupStart: 'À partir de',
        pickupEnd: 'Au plus tard',
        pickupTracking: 'Suivi :',
        pickupConfirm: 'Confirmer',
        pickupScheduleWindow: 'Fenêtre de ramassage',
        pickupEndAfterStart: "L'heure de fin doit être au moins 4 h après l'heure de début (entre 8 h et 17 h).",
        pageLabel: 'Page',
        pageOf: 'sur',
        totalLabel: 'au total',
        statusCreated: 'Créé',
        statusPendingPickup: 'En attente ramassage',
        statusPickupPlanned: 'Ramassage planifié',
        statusInSystem: 'Dans le système',
        statusInTransit: 'En transit',
        statusPickedUp: 'Ramassé',
        statusAtWarehouse: 'Au entrepôt',
        statusOutForDelivery: 'En livraison',
        statusDelivered: 'Livré',
        statusDeliveryFailed: 'Échec livraison',
        statusAttention: 'ATTENTION',
        statusCanceled: 'Annulé',
        statusUnknown: 'Inconnu',
        trackingModalTitle: 'Informations de suivi',
        trackingUnavailable: 'Suivi indisponible.',
        trackingError: 'Impossible de charger le suivi : ',
        trackingSummaryTitle: 'Résumé',
        trackingSummaryOrder: 'Commande',
        trackingSummaryCarrier: 'Intégration',
        trackingSummaryStatus: 'Statut (GoLivro)',
        trackingSummaryNumbers: 'Numéros de suivi',
        trackingSummaryLastUpdate: 'Dernière mise à jour',
        trackingSectionObibox: 'État chez le transporteur (Obibox)',
        trackingSectionIshipOrder: 'Suivi iShip (commande)',
        trackingSectionIshipByTracking: 'Suivi par numéro',
        trackingSectionLar: 'Commande Livraison à Rabais',
        trackingSectionMachool: 'État chez le transporteur (Machool)',
        trackingMachoolProvider: 'Transporteur',
        trackingMachoolExpected: 'Livraison prévue',
        trackingMachoolDelivered: 'Livré le',
        trackingColStatus: 'Statut',
        trackingColDate: 'Date',
        trackingColLocation: 'Lieu',
        trackingColDescription: 'Description',
        trackingColNumber: 'Numéro',
        trackingOpenLink: 'Ouvrir le suivi transporteur',
        trackingLarDetailStatus: 'Statut transporteur',
        trackingLarTracking: 'Suivi',
        trackingRawJson: 'Données brutes (JSON)',
        trackingNoDetails: 'Aucun détail additionnel.',
        trackingErrorProvider: 'Erreur',
        trackingSyncOrderCta: 'Mettre à jour la commande',
        trackingSyncOrderSuccess: 'Statut transporteur synchronisé et commande mise à jour.',
        trackingSyncOrderPreserved:
            'Ramassage planifié conservé : le statut transporteur n’a pas écrasé le statut local.',
        trackingSyncOrderError: 'Impossible de synchroniser le statut : ',
        bulkSyncStatus: 'Synchroniser les statuts',
        bulkSyncStatusHint: 'Synchroniser le statut transporteur des expéditions sélectionnées',
        exportCsv: 'Exporter',
        exportCsvHint: 'Exporter la sélection, ou toutes les expéditions du filtre, en CSV',
        exportCsvEmpty: 'Aucune expédition à exporter.',
        exportCsvError: 'Export impossible : ',
        bulkSyncStatusSuccess: '{count} statut(s) synchronisé(s).',
        bulkSyncStatusSuccessWithPreserved: '{synced} synchronisé(s), {preserved} conservé(s) (ramassage planifié).',
        bulkSyncStatusPartial: '{ok} synchronisé(s), {failed} en échec.',
        bulkSyncStatusAllFailed: 'Impossible de synchroniser les expéditions sélectionnées.',
        editModalTitle: 'Modifier l’expédition',
        editModalHint:
            'Cette action annule l’expédition actuelle puis recrée une nouvelle expédition avec les informations mises à jour.',
        editPackageCountDecrease: 'Diminuer le nombre de colis',
        editPackageCountIncrease: 'Augmenter le nombre de colis',
        editPackageCountHint:
            'Les colis ajoutés reprennent le format du dernier colis. Un nombre plus bas retire des colis à la fin. L’expédition est recalculée.',
        editPickupSection: 'Ramassage',
        editPickupName: 'Nom',
        editPickupStreet: 'Adresse',
        editPickupCity: 'Ville',
        editPickupPostalCode: 'Code postal',
        editPickupPhone: 'Téléphone',
        editDeliverySection: 'Livraison',
        editDeliveryName: 'Nom',
        editDeliveryStreet: 'Adresse',
        editDeliveryCity: 'Ville',
        editDeliveryPostalCode: 'Code postal',
        editDeliveryPhone: 'Téléphone',
        editDeliveryEmail: 'Courriel',
        editCommentsLabel: 'Commentaire de livraison',
        editConfirm: 'Confirmer la modification des informations et recréer l’expédition ?',
        editConfirmCta: 'Modifier et recréer',
        editSuccess: 'Informations mises à jour. L’expédition a été recréée.',
        editError: 'Impossible de modifier l’expédition: ',
        editTrackingPrefix: 'Nouveau suivi: ',
        duplicateConfirm:
            'Dupliquer cette expédition tier en nouvelle commande avec les mêmes informations et la même fenêtre de ramassage, à la prochaine date disponible selon la politique de ramassage ?',
        duplicateSuccess: 'Expédition dupliquée.',
        duplicateError: 'Impossible de dupliquer l’expédition : ',
        changeCarrierModalTitle: 'Changer de transporteur',
        changeCarrierModalHint:
            'Cette action annule l’expédition actuelle puis la recrée avec le transporteur sélectionné. Toutes les options disponibles sont affichées (pas seulement Économique / Express).',
        changeCarrierCurrent: 'Transporteur actuel :',
        changeCarrierCurrentTag: 'Actuel',
        changeCarrierColCarrier: 'Transporteur',
        changeCarrierColService: 'Service',
        changeCarrierColTransit: 'Transit',
        changeCarrierColPrice: 'Coût',
        changeCarrierDays: 'j',
        changeCarrierLoading: 'Chargement des cotations…',
        changeCarrierNoQuotes: 'Aucune cotation transporteur disponible.',
        changeCarrierQuoteError: 'Impossible de charger les cotations : ',
        changeCarrierConfirm:
            'Confirmer le changement de transporteur ? L’expédition actuelle sera annulée et recréée.',
        changeCarrierProceedWithoutCancel: 'Procéder sans annuler la première expédition',
        changeCarrierProceedWithoutCancelHint:
            'L’expédition actuelle est quand même annulée si le transporteur l’accepte. Si l’annulation échoue, la nouvelle expédition est créée et l’originale peut rester active chez le transporteur.',
        changeCarrierConfirmSkipCancel:
            'Confirmer le changement de transporteur ? Si l’annulation de l’expédition actuelle échoue, la nouvelle expédition sera quand même créée.',
        changeCarrierConfirmCta: 'Changer de transporteur',
        changeCarrierMachoolTag: 'Machool',
        changeCarrierSuccess: 'Transporteur modifié. L’expédition a été recréée.',
        changeCarrierSuccessPreviousNotCanceled:
            'Transporteur modifié. L’expédition d’origine n’a pas été annulée chez le transporteur.',
        changeCarrierError: 'Impossible de changer de transporteur : ',
        priceTesterOpen: 'Testeur de prix',
        priceTesterTitle: 'Testeur de prix third-party',
        priceTesterHint:
            'Toutes les options LAR, Obibox et Machool, sans agrégation Économique / Express. Les marges et le first mile se recalculent en direct.',
        priceTesterPickup: 'Adresse de ramassage',
        priceTesterDestination: 'Adresse de destination',
        priceTesterPickupPostalRequired: 'Choisissez une adresse de ramassage avec un code postal.',
        priceTesterDestPostalRequired: 'Choisissez une adresse de destination avec un code postal.',
        priceTesterSubmit: 'Obtenir les tarifs',
        priceTesterLoading: 'Chargement des tarifs…',
        priceTesterQuoteError: 'Impossible d’obtenir les tarifs : ',
        priceTesterLiveFields: 'Configuration live',
        priceTesterFirstMile: 'First mile ($)',
        priceTesterFirstMileHintExtra:
            '{{base}} + {{extraKm}} km × {{kmFee}} ({{hubKm}} km vers le hub, {{includedKm}} km inclus)',
        priceTesterFirstMileHintIncluded:
            '{{base}} ({{hubKm}} km vers le hub, {{includedKm}} km inclus)',
        priceTesterFirstMileHintUnavailable:
            '{{base}} — distance vers le hub indisponible, extra km non ajoutés',
        priceTesterLarMargin: 'Marge LAR (%)',
        priceTesterObiboxMargin: 'Marge Obibox (%)',
        priceTesterMachoolMargin: 'Marge Machool (%)',
        priceTesterLarTitle: 'Livraison à Rabais',
        priceTesterObiboxTitle: 'Obibox',
        priceTesterMachoolTitle: 'Machool',
        priceTesterNoLar: 'Aucune option LAR pour cette requête.',
        priceTesterNoObibox: 'Aucune option Obibox pour cette requête.',
        priceTesterNoMachool: 'Aucune option Machool pour cette requête.',
        priceTesterColCarrier: 'Transporteur',
        priceTesterColService: 'Service',
        priceTesterColTransit: 'Transit',
        priceTesterColPickup: 'Pickup',
        priceTesterColBase: 'Coût transporteur',
        priceTesterColFirstMile: 'Premier kilomètre',
        priceTesterColMargin: 'Marge',
        priceTesterColSell: 'Prix client',
        priceTesterColEta: 'ETA',
        priceTesterColObiboxCost: 'Coût Obibox',
        priceTesterColWithFirstMile: 'Obibox + first mile',
        priceTesterMerchant: 'Marchand (présélections)',
        priceTesterMerchantPlaceholder: 'Rechercher un marchand…',
        priceTesterMerchantHelp:
            'Applique les marges, first mile et formats de colis du marchand. Remplit aussi l’adresse de ramassage.',
        priceTesterMerchantClear: 'Retirer le marchand',
        priceTesterPackageSummary: '{{packages}} colis · {{formats}} format(s) envoyés aux transporteurs',
        larInvoiceOpen: 'Facture LAR',
        larInvoiceModalTitle: 'Rapprochement facture Livraison à Rabais',
        larInvoiceModalHint:
            'Importez le rapport Excel hebdomadaire LAR, ou le fichier de réponse aux écarts (details_ecarts). Pour un fichier d’écarts, seules les lignes « Écart maintenu » sont prises en charge ; le motif (colonne H) est repris sur la facture. Les lignes sont associées via le numéro de suivi. Les écarts sont refacturés (frais + marge) ; les commandes pas encore sur une facture marchand sont facturées au prix corrigé complet plutôt qu’à la seule différence.',
        larInvoiceFileLabel: 'Fichier Excel',
        larInvoiceChooseFile: 'Choisir un fichier',
        larInvoiceNoFile: 'Aucun fichier',
        larInvoiceRefLabel: 'Référence facture transporteur (interne)',
        larInvoiceAnalyze: 'Analyser',
        larInvoiceParsing: 'Analyse en cours…',
        larInvoiceSummaryRows: 'Lignes',
        larInvoiceSummaryMatched: 'Associées',
        larInvoiceSummaryExtras: 'Avec écart',
        larInvoiceSummaryFullOrders: 'Commandes non facturées (prix complet)',
        larInvoiceSummaryClientTotal: 'Total client à facturer',
        larInvoiceColEstimated: 'Estimé',
        larInvoiceColBilled: 'Facturé',
        larInvoiceColExtra: 'Écart transporteur',
        larInvoiceColClient: 'À facturer',
        larInvoiceColNotes: 'Notes facturation',
        larInvoiceColStatus: 'Statut',
        larInvoiceStatusUnmatched: 'Non trouvé',
        larInvoiceStatusInvoiced: 'Déjà facturé',
        larInvoiceStatusFullOrder: 'Commande complète',
        larInvoiceFullPriceHint: 'Prix complet',
        larInvoiceStatusExtra: 'Écart',
        larInvoiceStatusOk: 'OK',
        larInvoiceSelectAll: 'Tout sélectionner',
        larInvoiceNothingSelected: 'Sélectionnez des lignes à facturer.',
        larInvoiceSelectedTotal: '{{count}} ligne(s) — {{total}}',
        larInvoiceSubmit: 'Créer les factures',
        larInvoiceConfirm: 'Créer des factures pour {{count}} ligne(s) sélectionnée(s) ? Les écarts facturent la différence ; les commandes non facturées sont facturées au prix corrigé complet.',
        larInvoiceSuccess: '{{count}} facture(s) créée(s) : {{links}}',
        obiboxInvoiceOpen: 'Facture Obibox',
        obiboxInvoiceModalTitle: 'Rapprochement facture Obibox',
        obiboxInvoiceModalHint:
            'Importez le fichier Excel de détail Obibox (une ligne par colis). Les colis sont regroupés par commande (numéro de suivi ou hex Customer Order). Les écarts sont refacturés (frais + marge). Les commandes pas encore sur une facture marchand sont facturées au montant Obibox corrigé plus le premier mile, même sans écart.',
        obiboxInvoiceFileLabel: 'Fichier Excel',
        obiboxInvoiceChooseFile: 'Choisir un fichier',
        obiboxInvoiceNoFile: 'Aucun fichier',
        obiboxInvoiceRefLabel: 'Référence facture transporteur (interne)',
        obiboxInvoiceAnalyze: 'Analyser',
        obiboxInvoiceParsing: 'Analyse en cours…',
        obiboxInvoiceSummaryRows: 'Commandes',
        obiboxInvoiceSummaryPackages: 'Colis',
        obiboxInvoiceSummaryMatched: 'Associées',
        obiboxInvoiceSummaryExtras: 'Avec écart',
        obiboxInvoiceSummaryFullOrders: 'Commandes non facturées (prix complet)',
        obiboxInvoiceSummaryClientTotal: 'Total client à facturer',
        obiboxInvoiceColPackages: 'Colis',
        obiboxInvoiceColEstimated: 'Estimé',
        obiboxInvoiceColBilled: 'Coût réel',
        obiboxInvoiceColExtra: 'Écart transporteur',
        obiboxInvoiceColFirstMile: 'Premier mile',
        obiboxInvoiceColClient: 'À facturer',
        obiboxInvoiceColNotes: 'Notes facturation',
        obiboxInvoiceColStatus: 'Statut',
        obiboxInvoiceStatusUnmatched: 'Non trouvé',
        obiboxInvoiceStatusInvoiced: 'Déjà facturé',
        obiboxInvoiceStatusFullOrder: 'Commande complète',
        obiboxInvoiceFullPriceHint: 'Prix complet + premier mile',
        obiboxInvoiceStatusExtra: 'Écart',
        obiboxInvoiceStatusOk: 'OK',
        obiboxInvoiceSelectAll: 'Tout sélectionner',
        obiboxInvoiceNothingSelected: 'Sélectionnez des commandes à facturer.',
        obiboxInvoiceSelectedTotal: '{{count}} commande(s) — {{total}}',
        obiboxInvoiceSubmit: 'Créer les factures',
        obiboxInvoiceConfirm: 'Créer des factures pour {{count}} commande(s) sélectionnée(s) ? Les écarts facturent la différence ; les commandes non facturées sont facturées au prix corrigé complet, premier mile inclus.',
        obiboxInvoiceSuccess: '{{count}} facture(s) créée(s) : {{links}}',
        finalPriceGenerateNow: 'Générer les factures maintenant',
        finalPriceSave: 'Enregistrer les prix finaux',
        finalPriceSaveConfirm: 'Enregistrer le prix final du transporteur pour {{count}} ligne(s) sélectionnée(s) ? Les commandes non facturées seront ajoutées à la facture hebdomadaire. Les commandes déjà facturées (à la carte ou formulaire public) avec un écart reçoivent une facture d’ajustement immédiatement.',
        finalPriceAlreadyBilledNow: 'Les commandes déjà facturées (à la carte ou formulaire public) avec un écart sont facturées immédiatement, même si cette case est décochée.',
        finalPriceSaved: '{{count}} prix final(aux) enregistré(s).',
        finalPriceNothingSelected: 'Sélectionnez des lignes associées.',
        colFinalPrice: 'Prix final',
        setFinalPrice: 'Prix final',
        setFinalPriceTitle: 'Prix final du transporteur',
        setFinalPriceLabel: 'Montant facturé par le transporteur (avant marge)',
        setFinalPriceInvalid: 'Entrez un montant supérieur à zéro, avec au plus deux décimales.',
        setFinalPriceHelp: 'L’estimé est conservé. Si la commande n’est pas encore sur une facture marchand, le montant client est mis à jour et la facture hebdomadaire l’inclura.',
        setFinalPriceSaved: 'Prix final enregistré.',
        machoolInvoiceOpen: 'Facture Machool',
        machoolInvoiceModalTitle: 'Rapprochement facture Machool',
        machoolInvoiceModalHint: 'Importez le CSV de facture Machool. Les lignes sont associées par numéro de suivi, puis par ORD- suivi de l’identifiant de commande en hexadécimal. Le prix final enregistré est le sous-total avant taxes (combined_sub_total), pas le total taxes incluses. Les lignes d’ajustement s’ajoutent à la même expédition.',
        machoolInvoiceFileLabel: 'Fichier CSV',
        machoolInvoiceChooseFile: 'Choisir un fichier',
        machoolInvoiceNoFile: 'Aucun fichier',
        machoolInvoiceRefLabel: 'Référence facture transporteur (interne)',
        machoolInvoiceAnalyze: 'Analyser',
        machoolInvoiceParsing: 'Analyse en cours…',
        machoolInvoiceSummaryRows: 'Commandes',
        machoolInvoiceSummaryPackages: 'Lignes',
        machoolInvoiceSummaryMatched: 'Associées',
        machoolInvoiceSummaryExtras: 'Avec écart',
        machoolInvoiceSummaryFullOrders: 'Commandes non facturées (prix complet)',
        machoolInvoiceSummaryClientTotal: 'Total client à facturer',
        machoolInvoiceColPackages: 'Lignes',
        machoolInvoiceColEstimated: 'Estimé',
        machoolInvoiceColBilled: 'Coût réel',
        machoolInvoiceColExtra: 'Écart transporteur',
        machoolInvoiceColFirstMile: 'Premier mile',
        machoolInvoiceColClient: 'À facturer',
        machoolInvoiceColNotes: 'Notes facturation',
        machoolInvoiceColStatus: 'Statut',
        machoolInvoiceStatusUnmatched: 'Non trouvé',
        machoolInvoiceStatusInvoiced: 'Déjà facturé',
        machoolInvoiceStatusFullOrder: 'Commande complète',
        machoolInvoiceFullPriceHint: 'Prix complet + premier mile',
        machoolInvoiceStatusExtra: 'Écart',
        machoolInvoiceStatusOk: 'OK',
        machoolInvoiceSelectAll: 'Tout sélectionner',
        machoolInvoiceSelectedTotal: '{{count}} commande(s) — {{total}}',
        machoolInvoiceSubmit: 'Créer les factures',
        machoolInvoiceConfirm: 'Créer des factures pour {{count}} commande(s) sélectionnée(s) ? Les écarts facturent la différence ; les commandes non facturées sont facturées au prix corrigé complet, premier mile inclus.',
        machoolInvoiceSuccess: '{{count}} facture(s) créée(s) : {{links}}',
    },
    languageSelect: {
        english: 'Anglais',
        french: 'Français',
    },
    deliveries: {
        title: 'Livraisons en cours',
        newDelivery: 'Nouvelle livraison',
        assignDelivery: 'Assigner la livraison',
        addOrder: 'Ajouter une commande',
        generateRecurringOrders: 'Générer les commandes',
        recurringOrders: 'Commandes récurrentes',
        deliverBefore: 'Livrer avant',
        created: 'Créé',
        assigned: 'Assigné',
        arrived: 'Arrivé',
        onTheWay: 'En route',
        completed: 'Complété',
        cancelled: 'Annulé',
        returned: 'Retourné',
        assign: 'Assigner',
        createRoute: 'Créer une route',
        addToRoute: 'Ajouter à une route',
        modifyOriginAddress: 'Modifier l\'adresse d\'origine',
        modifyDeadline: 'Modifier le délai',
        notifications: 'Notifications',
        filters: 'Filtres',
        unassigned: 'Non assignés',
        noDriver: 'Sans livreur',
        urgentDelivery: 'Livraison urgentes',
        fourHourDelivery: 'Livraison 4h',
        flexibleBusiness: 'Flexible Entreprise',
        flexiblePM: 'Flexible avant 21',
        flexibleWindow: 'Flexibles (multi-jours)',
        flexibleBefore: 'Flexible — avant {{date}}',
        lateOrders: 'Commandes en retard (ETA)',
        onlineDrivers: 'Livreurs en ligne',
        pickup: 'Ramassage',
        destination: 'Destination',
        splitOmitsDestination: 'Destination omise. Le ramassage et la livraison sont séparés : cet arrêt ne comprend que le ramassage.',
        splitOmitsPickup: 'Ramassage omis. Le ramassage et la livraison sont séparés : cet arrêt ne comprend que la livraison.',
        splitTransitHub: 'Adresse de transit. Cette destination est un point de chute avant l\'expédition par un transporteur tiers.',
        splitTwoLegs: 'Cette commande a plusieurs livraisons. Cet arrêt ne couvre qu\'un des segments.',
        samePickup: {
            badgeLabel: '{{driver}} déjà en route',
            badgeLabelMany: '{{count}} livreurs déjà en route',
            banner: '{{driver}} se rend déjà à cette adresse et n\'est pas encore passé. Évitez d\'envoyer un deuxième chauffeur, sauf si les colis ne rentrent pas dans un seul véhicule.',
            bannerMany: '{{drivers}} se rendent déjà à cette adresse et ne sont pas encore passés. Évitez d\'envoyer un autre chauffeur, sauf si les colis ne rentrent pas dans un seul véhicule.',
            driverTag: 'Se rend déjà à cette adresse',
        },
        callTime: 'Temps d\'appel',
        deadline: 'Deadline',
        fees: 'Frais',
        driver: 'Livreur',
        recurringOrdersGeneratedSuccess: 'Commandes récurrentes générées avec succès !',
        noRecurringOrdersGenerated: 'Aucune commande récurrente à générer.',
        confirmDeleteRecurringOrder: 'Êtes-vous sûr de vouloir supprimer cette commande récurrente ?',
        recurringOrderDeletedSuccess: 'Commande récurrente supprimée avec succès.',
        errorDeletingRecurringOrder: 'Erreur lors de la suppression de la commande récurrente.',
        errorOccurredDeletingRecurringOrder: 'Une erreur est survenue lors de la suppression de la commande récurrente.',
        recurringDeliveriesDescription: 'Gérez vos livraisons récurrentes. Ajoutez des livraisons qui se répètent chaque semaine. Les commandes sont générées automatiquement chaque semaine.',
        addRecurringOrder: 'Ajouter une commande récurrente',
        modifyRecurringOrder: 'Modifier la commande récurrente',
    },
    drivers: {
        title: 'Chauffeurs',
        incidents: 'Incidents des chauffeurs',
        locationHistory: 'Historique des localisations des chauffeurs',
        headers: {
            name: 'Nom',
            lastname: 'Nom de famille',
            email: 'Courriel',
            phoneNumber: 'Numéro de téléphone',
            password: 'Mot de passe'
        },
        actions: {
            modifyTheDriver: 'Modifier le livreur',
            newDriver: 'Nouveau livreur',
            modifyPasswordFor: 'Modifier le mot de passe pour'
        },
        app: {
            title: 'Application mobile',
            intro: 'Les livreurs utilisent l\'application GoLivro Driver.',
            android: 'Android',
            ios: 'iOS',
            sendTitle: 'Envoyer un lien par courriel',
            platform: 'Plateforme',
            send: 'Envoyer',
            sent: 'Le lien a été envoyé.',
            sendFailed: 'Impossible d\'envoyer le lien. Veuillez réessayer.',
        }
    },
    driversLocationsHistory: {
        mapTitle: 'Positions des livreurs selon le temps',
        searchDriver: 'Rechercher un livreur...',
        selectDateTimeForLocations: 'Sélectionnez une plage de dates et d\'heures pour visualiser les emplacements des livreurs. Utilisez le curseur pour parcourir la chronologie.',
        selectDatesSlider: 'Sélectionnez des dates et déplacez le curseur',
        selectDriver: 'Sélectionner un livreur',
        loadingMap: 'Chargement de la carte...'
    },
    merchants: {
        title: 'Commerçants',
        registration: {
            title: 'Inscription commerce',
            account: 'Compte',
            profile: 'Profil',
            confirmation: 'Confirmation',
            success: 'Inscription réussie!',
            termsBeforeLink: 'En continuant, j\'accepte les ',
            termsLinkText: 'conditions d\'utilisation',
            termsAfterLink: '.',
            signInPrompt: 'Déjà un compte ? Connectez-vous'
        },
        form: {
            generalInfo: {
                name: 'Nom',
                businessName: 'Nom de l\'entreprise',
                billingEmail: 'Courriel facturation',
                multipleEmailsNote: 'Si plusieurs, séparer par des virgules',
                phone: 'Numéro de téléphone',
                address: 'Adresse',
                pickupComment: 'Commentaire pour la cueillette',
                pickupCommentPlaceholder: 'Instructions spéciales pour la cueillette',
                contactPerson: 'Nom de la personne contact',
                contactPhone: 'Numéro de téléphone de la personne contact',
                contactEmail: 'Courriel de la personne contact',
                merchantType: 'Type de commerce',
                merchantTypePlaceholder: 'Type de commerce',
                ueatDeliveryFee: 'UEAT: frais livraison client',
                ueatOptions: {
                    disable: 'Désactiver',
                    fixedFee: '$ frais fixe',
                    percentage: '% pourcentage'
                }
            },
            settings: {
                useSMS: 'Utilise SMS',
                usePOD: 'Utilise preuves livros',
                useSignature: 'Utilise signature',
                usePOS: 'Utilise service paiement',
                hasDrivers: 'Utilise ses chauffeurs',
                useDeliveryZones: 'Utilise les zones de livraison',
                notifEmailConsignee: 'Notifications de statut par courriel au destinataire',
                notifEmailSender: 'Notifications de statut par courriel à l’expéditeur'
            },
            sections: {
                contact: 'Coordonnées et adresse de ramassage',
                delivery: 'Options de livraison',
                notifications: 'Notifications par courriel',
                square: 'Square',
            },
            square: {
                connect: 'Connecter Square',
                disconnect: 'Déconnecter Square',
                connected: 'Compte Square connecté',
                disconnected: 'Aucun compte Square connecté',
                connectSuccess: 'Votre boutique Square est maintenant connectée.',
                connectError: 'La connexion Square a échoué. Veuillez réessayer.',
                connectDenied: 'La connexion Square a été refusée.',
                disconnectConfirm: 'Déconnecter votre compte Square ? Les nouvelles commandes en ligne ne seront plus importées.',
            },
            invoicing: {
                billingCycle: 'Cycle de facturation',
                billingCyclePlaceholder: 'Cycle de facturation',
                serviceFees: 'Frais de service',
                informatique: 'Service informatique',
                weekly: 'HEBDOMADAIRE',
                biweekly: '2 SEMAINES',
                monthly: 'MENSUEL',
                usageBased: 'À LA CARTE'
            }
        },
        validation: {
            nameRequired: 'Veuillez indiquer un nom',
            emailRequired: 'Veuillez indiquer un courriel',
            passwordRequired: 'Veuillez indiquer un mot de passe',
            passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
            passwordConfirmationRequired: 'Veuillez confirmer le mot de passe',
            passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
            merchantTypeRequired: 'Veuillez spécifier le type de commerce',
            addressRequired: 'Veuillez choisir une adresse parmi la liste déroulante',
            phoneRequired: 'Veuillez indiquer un numéro de téléphone',
            contactNameRequired: 'Veuillez indiquer le nom du contact',
            contactPhoneRequired: 'Veuillez indiquer le numéro de la personne contact',
            termsRequired: 'Vous devez accepter les conditions d\'utilisation pour continuer'
        }
    },
    users: {
        title: 'Gestion des utilisateurs',
        name: 'Nom',
        email: 'Courriel',
        role: 'Rôle',
        actions: {
            modifyUser: 'Modifier l\'utilisateur',
            newUser: 'Nouveau utilisateur'
        }
    },
    routes: {
        title: 'Routes en cours',
        history: 'Historique des routes',
        confirmRemoveRoute: 'Êtes-vous sûr de vouloir supprimer cette route ? Les commandes seront remises dans la liste des commandes non assignées.',
        confirmAcceptRoute: 'Êtes-vous sûr de vouloir générer cette route ?',
        confirmAcceptAllRoutes: 'Êtes-vous sûr de vouloir générer {count} route(s) ?',
        acceptingRoutes: 'Acceptation...',
        acceptRoute: 'Accepter la route',
        removeRoute: 'Supprimer la route',
        acceptRoutes: 'Accepter les routes',
        shiftSuggestions: {
            refresh: 'Suggestions chauffeurs',
            countLabel: 'suggestion(s)',
            estimatedDuration: '~{minutes} min estimées',
            someUncovered: 'Certains chauffeurs n\'ont pas de quart couvrant la route',
            error: 'Impossible de charger les suggestions chauffeurs.',
        },
        headers: {
            itinerary: 'Itinéraire',
            completedStops: 'Arrêts complétés',
            distance: 'Distance',
            duration: 'Durée',
            driver: 'Chauffeur',
            deliveries: 'Livraisons',
            actions: 'Actions',
        },
        groups: {
            unscheduled: 'Non planifiées',
        },
        dragHint: 'Glissez un arrêt vers la liste d’un autre livreur pour y déplacer la livraison (ramassage + livraison). Réordonnez les arrêts dans une liste comme avant.',
    },
    routeView: {
        route: 'Route',
        steps: 'Étapes',
        routeCompleted: 'Route complétée:',
        type: 'Type',
        order: 'Commande',
        scheduleDeadline: 'Horaire/Échéance',
        eta: 'ETA',
        estimatedTime: 'Temps estimé',
        actualTime: 'Temps réel',
        driverPayment: '$ livreur',
        delivery: 'Livraison',
        headers: {
            driver: 'Chauffeur',
            distance: 'Distance',
            address: 'Adresse',
        },
    },
    schedule: {
        roadSchedules: 'Horaires de route',
        merchantSchedule: 'Horaire 5@8',
        servicesAttitres: 'Services attitrés',
        logs: 'Historique des horaires',
        title: {
            confirmDriverShift: 'Veuillez confirmer les heures de travail du livreur'
        },
        actions: {
            addShift: 'Ajouter un quart de travail',
            generateShifts: 'Générer les shifts de cette période',
            filter: 'Filtrer',
            today: 'Aujourd\'hui',
            byWeek: 'Par Semaine',
            byDay: 'Par Jour',
            byCalendar: 'Calendrier',
            validateHours: 'Valider les heures',
            recurringShifts: 'Quarts de travail récurrents',
            modify: 'Modifier',
            add: 'Ajouter',
            bulkConfirmDriver: 'Confirmer les quarts',
            bulkUnconfirmDriver: 'Déconfirmer les quarts',
            bulkUnassignDriver: 'Désassigner les livreurs',
            bulkDeleteShifts: 'Supprimer les quarts',
            selectAll: 'Tout sélectionner',
        },
        bulkConfirm: {
            confirmSelectedPrompt: 'Confirmer la présence pour {count} quart(s) sélectionné(s)?',
            successSelected: '{count} quart(s) confirmé(s).',
            unconfirmSelectedPrompt: 'Déconfirmer {count} quart(s) sélectionné(s)?',
            successUnconfirmed: '{count} quart(s) déconfirmé(s).',
            unassignSelectedPrompt: 'Désassigner le livreur de {count} quart(s) sélectionné(s)?',
            successUnassigned: '{count} quart(s) désassigné(s).',
            deleteSelectedPrompt: 'Supprimer {count} quart(s) sélectionné(s)?',
            successDeleted: '{count} quart(s) supprimé(s).',
        },
        stats: {
            terrain: 'Terrain',
            serviceAttitre: 'Service attitré',
            guaranteed: 'revenus garantis',
            uniqueDrivers: 'Livreurs uniques',
        },
        filters: {
            withWho: 'Avec qui',
            terrain: 'Terrain',
            serviceAttitre: 'Service attitré',
            allShifts: 'Tous les shifts',
            freeShifts: 'Shift libres',
            guaranteedShifts: 'Shift garanties',
            zones: 'Zones'
        },
        suggestions: {
            title: 'Suggestions',
            generate: 'Générer les suggestions',
            applyAll: 'Appliquer toutes les suggestions',
            removeAll: 'Supprimer les suggestions',
            show: 'Afficher les suggestions',
            hide: 'Masquer les suggestions',
            replaceExistingOnApply: 'Remplacer les shifts actuels par les suggestions',
            confirmApply: 'Êtes-vous sûr de vouloir appliquer toutes les suggestions?',
            confirmApplyReplace: 'Êtes-vous sûr de vouloir remplacer tous les shifts actuels par les suggestions?',
            confirmApplyDay: 'Êtes-vous sûr de vouloir appliquer les suggestions pour {day}?',
            confirmApplyDayReplace: 'Êtes-vous sûr de vouloir remplacer les shifts actuels de {day} par les suggestions?',
        },
        messages: {
            noShiftsForDate: 'Aucun shifts à cette date.',
            confirmGenerate: 'Il existe déjà des shifts pour cette période. Voulez-vous quand même générer de nouveaux shifts ?',
            errorOccurred: 'Une erreur est survenue, réessayez plus tard',
            errorOccurredShort: 'Une erreur est survenue',
            confirmDelete: 'Etes vous sur de vouloir supprimer?'
        },
        days: {
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
            saturday: 'Samedi',
            sunday: 'Dimanche'
        },
        calendar: {
            to: 'au',
            period14: '2 semaines',
            period21: '3 semaines',
            period28: '4 semaines',
            noShifts: '—',
            noRequirement: 'Aucun besoin',
            cellTitle: '{filled}h comblées sur {total}h ({percent}%)'
        },
        heatmap: {
            title: 'Couverture hebdomadaire',
            hour: 'Heure',
            total: 'Total',
            coverageLabel: 'Couverture affichée',
            coverageAssigned: 'Assigné',
            coveragePlanned: 'Planifié',
            coverageOnRoad: 'En route',
            coverageFillRate: 'Couverture',
            subtitle: {
                assigned: 'Nombre de livreurs assignés par tranche horaire (shifts avec DRID).',
                planned: 'Nombre de shifts planifiés par tranche horaire (tous les shifts).',
                onRoad: 'Nombre de routes terminées par tranche horaire (temps réel start_time → end_time).',
                coverage: 'Livreurs assignés par tranche horaire. Couleur : assigné / planifié (< 70 % rouge, 70–90 % jaune, 90 %+ vert).',
            },
            cellTitle: {
                assigned: '{value} livreur(s) assigné(s)',
                planned: '{value} shift(s) planifié(s)',
                onRoad: '{value} route(s) en service',
                coverage: '{assigned}/{planned} livreur(s)',
            },
            cellTitleWithPercent: {
                coverage: '{assigned}/{planned} livreur(s) ({percent}%)',
            },
            legendGreen: '90 %+',
            legendYellow: '70–90 %',
            legendRed: '< 70 %',
        },
        roadScheduleHeatmap: {
            shiftCategoryLabel: 'Type de shifts affichés',
            normalShifts: 'Shifts normaux',
            suggestedShifts: 'Shifts suggérés',
            subtitle: {
                normal: 'Couverture des shifts normaux du squelette terrain (préassignés DEFAULT_DRID / planifiés). Couleur : assigné / planifié (< 70 % rouge, 70–90 % jaune, 90 %+ vert).',
                suggested: 'Couverture des shifts suggérés du squelette terrain (préassignés DEFAULT_DRID / planifiés). Couleur : assigné / planifié (< 70 % rouge, 70–90 % jaune, 90 %+ vert).',
            },
        },
        merchantScheduleHeatmap: {
            subtitle: 'Couverture du squelette 5@8 (préassignés DEFAULT_DRID / planifiés). Couleur : assigné / planifié (< 70 % rouge, 70–90 % jaune, 90 %+ vert).',
        },
        headers: {
            driver: 'Livreur',
            merchant: 'Commerce',
            dedicatedDrivers: 'Service de placement de chauffeurs',
            city: 'Ville',
            startAddress: 'Lieu de départ',
            schedule: 'Horaire',
            date: 'Date',
            confirmation: 'Confirmation',
            recurrent: 'Récurrent',
            actions: 'Actions'
        },
        status: {
            noDriverAssigned: 'Aucun livreur assigné',
            driverConfirmed: '(LIVREUR)',
            driverNotConfirmed: 'À confirmer',
            merchantApproved: '(COMMERCE)'
        },
        noDriverAssigned: 'Aucun livreur assigné',
        noShifts: 'Aucun quarts de travail',
        shiftPublishInfo: 'Publiez des quarts de travail selon vos besoins. Les membres de notre équipe s\'occuperont de placer des chauffeurs à votre commerce qui travailleront avec vous pour l\'ensemble du shift.',
        glossary: {
            today: 'Aujourd\'hui',
            to: 'au',
            aShift: 'un shift'
        },
        shiftToConfirmWarning1: 'Cliquez sur le bouton \'Valider\' pour approuver les heures des quarts de travail.',
        shiftToConfirmWarning2: ' quart(s) de travail à confirmer.',
        driverConfigMessage1: 'Les quarts de travails récurrents sont répétés chaque semaine.',
        driverConfigMessage2: 'Ils sont générés chaque:',
        cannotModifyAfterConfirmWarning: 'Une fois le quart de travail confirmé, il ne sera plus possible d\'apporter des modifications.',
        driverAvailabilities: {
            title: 'Disponibilités des livreurs',
            subtitle: 'Créer, modifier ou supprimer les plages de disponibilité (ponctuelles ou chaque semaine).',
            addTitle: 'Ajouter une disponibilité',
            editTitle: 'Modifier la disponibilité',
            weekReferenceDate: 'Semaine (date de référence)',
            driver: 'Livreur',
            selectDriver: 'Choisir un livreur',
            referenceDate: 'Date de référence',
            referenceDateHelp: 'Pour une disponibilité récurrente, cette date détermine le jour de la semaine. Les entrées affichées correspondent à la semaine contenant cette date.',
            recurringWeekly: 'Chaque semaine (récurrent)',
            dateOrRecurrence: 'Date / jour',
            start: 'Début',
            end: 'Fin',
            validationDriver: 'Veuillez sélectionner un livreur.',
            validationMissing: 'Veuillez remplir la date et les heures.',
            createdAt: 'Créé le',
            updatedAt: 'Modifié le',
        }
    },
    business: {
        title: 'Paramètres d\'entreprise',
    },
    menu: {
        title: 'Menu',
        mainMenu: 'Menu Principal',
        driverLocationHistory: 'Historique des Positions des Livreurs',
        deliveryServiceSettings: 'Paramètres du Service de Livraison',
        autoDispatchSettings: 'Paramètres de Dispatch Automatique',
        management: 'Gestion',
        manageMerchants: 'Gérer les Commerces',
        manageDrivers: 'Gérer les Livreurs',
        manageOrders: 'Gérer les Commandes',
        integration: 'Intégration',
        merchantIntegration: 'Intégration des Commerces',
        driverIntegration: 'Intégration des Livreurs',
        emailPreferences: 'Préférences de courriel',
        shiftConfirmReminderLabel: 'Recevoir un rappel quotidien par courriel des quarts de travail non confirmés',
        shiftConfirmationLabel: 'Recevoir une confirmation pour chaque quart de travail ajouté',
        driverAssignedToShiftLabel: 'Recevoir une notification quand un livreur est assigné à un quart',
        pickupFailedLabel: 'Recevoir un courriel lors d’un échec de ramassage',
        deliveryFailedLabel: 'Recevoir un courriel lors d’un échec de livraison',
        orderStatusSenderLabel: 'Mises à jour de statut de commande',
        defaultLabel: 'Préférence non spécifiée',
        preference: 'Préférence',
        integrations: {
            shopify: 'Shopify',
            shopifyDescription: 'Installez l’application On Ship Ça pour importer vos commandes Shopify.',
            shopifyCta: 'Installer l’application',
            deliverect: 'Deliverect',
            deliverectDescription: 'Connectez Deliverect pour importer vos commandes en ligne.',
            deliverectCta: 'Voir l’intégration',
            ueat: 'Ueat',
            ueatDescription: 'Contactez-nous pour connecter votre restaurant Ueat.',
            ueatCta: 'Nous contacter',
        },
    },
    promoCode: {
        title: 'Codes promo',
    },
    zones: {
        title: 'Zones',
        description: 'Gérer vos zones de livraison',
        addZone: 'Ajouter une zone',
        editZone: 'Modifier la zone',
        deleteZone: 'Supprimer la zone',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette zone ?',
        name: 'Nom de la zone',
        zoneDescription: 'Description',
        color: 'Couleur',
        center: 'Point central',
        coordinates: 'Coordonnées de la zone',
        latitude: 'Latitude',
        longitude: 'Longitude',
        addPoint: 'Ajouter un point',
        removePoint: 'Supprimer le point',
        saveSuccess: 'Zone enregistrée avec succès',
        deleteSuccess: 'Zone supprimée avec succès',
        saveError: 'Échec de l\'enregistrement de la zone',
        deleteError: 'Échec de la suppression de la zone',
        loadError: 'Échec du chargement des zones',
        noZones: 'Aucune zone configurée',
        drawOnMap: 'Dessiner sur la carte',
        clearDrawing: 'Effacer le dessin',
        clickMapToAdd: 'Cliquez sur la carte pour ajouter des points. Cliquez sur les marqueurs existants pour les supprimer.',
        clickToRemove: 'Cliquez pour supprimer le point',
        postalCodes: 'Codes postaux (FSA, ex. H1A, J4B)',
        showFsaOnMap: 'Afficher les FSA sur la carte',
        enterPostalCodesToShowFsa: 'Saisissez au moins un code postal (FSA) pour afficher les limites sur la carte.',
        fsaBoundariesError: 'Impossible de charger les limites FSA. Vérifiez que le service Python est démarré.',
    },
    deliveryZones: {
        title: 'Zones de livraison (destinations)',
        description: 'Définir les codes postaux (FSA) où vous livrez. Par défaut pour tous les commerces, ou spécifique à un commerce. Si une adresse de livraison est hors zone, les options tierces (Obibox) sont proposées.',
        addZone: 'Ajouter une zone',
        editZone: 'Modifier la zone',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette zone de livraison ?',
        defaultZone: 'Zone par défaut (tous les commerces)',
        merchantOverride: 'Commerce spécifique',
        selectMerchant: 'Sélectionner un commerce',
        postalCodes: 'Codes postaux FSA (ex. H1A, J4B, J4Y)',
        postalCodesPlaceholder: 'H1A, J4B, J4Y (séparés par des virgules)',
        saveSuccess: 'Zone de livraison enregistrée',
        saveError: 'Échec de l\'enregistrement',
        deleteError: 'Échec de la suppression',
        loadError: 'Échec du chargement',
        noZones: 'Aucune zone de livraison configurée. Les adresses hors de la région par défaut (Montréal, Laval, Rive-Sud) proposeront les livraisons tierces.',
        scope: 'Portée',
        zoneType: 'Type de zone',
        requiredPostalCodes: 'Veuillez saisir au moins un code postal (FSA).',
    },
    localDeliveryZones: {
        title: 'Zones locales (hubs)',
        description: 'Zones géographiques (ex: Montréal, Québec). Même zone = tarif standard; zones différentes = long_distance_rate.',
        addZone: 'Ajouter une zone locale',
        editZone: 'Modifier la zone',
        zoneIdentifier: 'Zone',
        zoneIdentifierHelp: 'Ex: montreal, quebec_city (minuscules, underscores)',
        requiredIdentifier: 'Identifiant de zone requis (ex: montreal, quebec_city)',
        pickupWeekdays: 'Jours de ramassage',
        pickupWeekdaysHelp: 'Jours où le ramassage local est disponible (ex: lun–ven pour Québec).',
        dayMon: 'Lun',
        dayTue: 'Mar',
        dayWed: 'Mer',
        dayThu: 'Jeu',
        dayFri: 'Ven',
        daySat: 'Sam',
        daySun: 'Dim',
    },
    invoice: {
        merchantInvoices: 'Factures des Commerces',
        driverReceipts: 'Reçus des Livreurs',
        pleaseSpecifyStartDate: 'Veuillez spécifier une date de début',
        pleaseSpecifyEndDate: 'Veuillez spécifier une date de fin',
        pleaseChooseBillingCycle: 'Veuillez choisir un cycle de facturation',
        invoicesAlreadyGenerated: 'Attention! Les factures ont déjà été générées pour cette période. Souhaitez-vous les re-générer?',
        confirmDeleteInvoices: 'Êtes-vous sûr de vouloir supprimer ces factures?',
        confirmRefundOnDelete: 'Certaines de ces factures ont un paiement associé. Souhaitez-vous rembourser le(s) paiement(s) également?',
        start: 'Début',
        end: 'Fin',
        periodFilter: 'Filtre période',
        issueDate: 'Date d\'émission',
        billingPeriod: 'Période de facturation',
        invoiceAmount: 'Montant facture',
        positiveInvoices: 'Factures positives',
        negativeInvoices: 'Factures négatives',
        billingCycle: 'Cycle facturation',
        paymentMethod: 'Mode de paiement',
        paymentTransaction: 'Transaction de paiement',
        transactionId: 'ID transaction',
        currency: 'Devise',
        reference: 'Référence',
        banking: 'Bancaire',
        creditCard: 'Carte de crédit',
        paidNotPaid: 'Payé/Pas payé',
        activeStatus: 'Statut facture',
        activeInvoices: 'Actives',
        canceledInvoices: 'Annulées',
        allInvoices: 'Toutes',
        numberOfInvoices: 'Nb Factures',
        serviceFees: 'Frais service',
        taxable: 'Taxable',
        nonTaxable: 'NON Taxable',
        gst: 'TPS',
        qst: 'TVQ',
        net: 'NET',
        invoiceNumber: '# Facture',
        viewed: 'Vu',
        margin: 'Marge ($/%)',
        bankFiles: 'Fichiers bancaires',
        chargeCreditCard: 'Débiter carte de crédit',
        confirmChargeCreditCard: 'Débiter la carte de crédit pour {{count}} facture(s) sélectionnée(s) ?',
        chargeCreditCardHint: 'Débit de {{count}} facture(s) sur les méthodes de paiement enregistrées.',
        chargeCreditCardCanClose: 'Vous pouvez fermer cette fenêtre. Les débits carte de crédit continueront en arrière-plan.',
        chargeCreditCardCompleted: 'Les débits carte de crédit sont terminés avec succès.',
        chargeCreditCardCompletedWithErrors: 'Terminé : {{succeeded}} réussie(s), {{failed}} échouée(s).',
        chargeCreditCardFailed: 'Le débit carte de crédit a échoué.',
        chargeCreditCardStatus: {
            queued: 'En attente',
            processing: 'En traitement',
            completed: 'Terminé',
            failed: 'Échec',
        },
        depositReconciliation: 'Rapprochement dépôts carte de crédit',
        depositReconciliationHint: 'Exportez un CSV de rapprochement entre les factures actives payées par carte de crédit et les dépôts Global Payments pour la période sélectionnée.',
        depositReconciliationRefundedHint: 'Mode factures remboursées : uniquement les factures annulées (ACTIVE=0) de la période, avec leurs transactions SALE + REFUND.',
        depositReconciliationRefundedOnly: 'Factures remboursées uniquement (annulées)',
        depositReconciliationInvoiceTitle: 'Rapprochement carte de crédit — facture #{{miid}}',
        depositReconciliationInvoiceHint: 'Rapprochement de la facture #{{miid}} avec les dépôts Global Payments. Un courriel sera envoyé lorsque le fichier CSV sera prêt.',
        depositReconciliationRefundHint: 'Rapprochement SALE + REFUND de la facture #{{miid}} avec les dépôts Global Payments (Deposit ID, dates, montants). Un courriel sera envoyé lorsque le fichier CSV sera prêt.',
        confirmDepositReconciliationInvoice: 'Lancer le rapprochement dépôts carte de crédit pour la facture #{{miid}} ?',
        confirmRefundDepositReconciliation: 'Lancer le rapprochement dépôts pour le SALE et les REFUND de la facture #{{miid}} ?',
        depositReconciliationNotCreditCard: 'Cette facture n’a pas été payée par carte de crédit.',
        startDepositReconciliation: 'Démarrer le rapprochement',
        startDepositReconciliationRefunded: 'Démarrer le rapprochement (remboursées)',
        refundLookupTitle: 'Remboursements carte de crédit — facture #{{miid}}',
        refundLookupHint: 'Recherche les transactions REFUND Global Payments liées au paiement (TRN_…) de cette facture annulée. Ajustez les dates si le remboursement a été effectué plus tard.',
        refundLookupSearch: 'Rechercher les remboursements',
        refundLookupReconcileDeposits: 'Rapprochement dépôts (SALE + REFUND)',
        refundLookupSale: 'Transaction de paiement (SALE)',
        refundLookupRefundId: 'ID remboursement',
        refundLookupReference: 'Référence',
        refundLookupNoneFound: 'Aucun remboursement trouvé entre {{from}} et {{to}} pour ce payment_id.',
        depositReconciliationCanClose: 'Vous pouvez fermer cette fenêtre. Un courriel sera envoyé à {{email}} lorsque le fichier sera prêt.',
        depositReconciliationEmailSent: 'Le fichier est prêt. Un courriel avec le CSV en pièce jointe a été envoyé.',
        depositReconciliationFailed: 'Le rapprochement a échoué. Un courriel d’erreur a été envoyé.',
        depositReconciliationStatus: {
            queued: 'En attente',
            processing: 'En traitement',
            completed: 'Terminé',
            failed: 'Échec',
        },
        markAsPaid: 'Marqué payé',
        generateInvoices: 'Générer les factures',
        generateInvoicesCanClose: 'Vous pouvez fermer cette fenêtre. La génération des factures continuera en arrière-plan.',
        generateInvoicesCompleted: 'La génération des factures est terminée avec succès.',
        generateInvoicesCompletedWithErrors: 'Terminé : {{succeeded}} réussie(s), {{failed}} échouée(s).',
        generateInvoicesFailed: 'La génération des factures a échoué.',
        generateInvoicesStatus: {
            queued: 'En attente',
            processing: 'En traitement',
            completed: 'Terminé',
            failed: 'Échec',
        },
        ordersWithoutInvoiceOpen: 'Commandes et quarts non facturés',
        ordersWithoutInvoiceTitle: 'Commandes et quarts sans facture',
        ordersWithoutInvoiceHint:
            'Liste les commandes de commerces facturables sans ligne de rapport et les quarts issus d’un horaire commerçant sans ligne de facture, sur la période. Sélectionnez ce qu’il faut facturer (factures commandes et/ou quarts seulement, sans frais de cycle).',
        ordersWithoutInvoiceOrdersHeading: 'Commandes non facturées',
        ordersWithoutInvoiceFetchType: 'Inclure',
        ordersWithoutInvoiceFetchBoth: 'Commandes et quarts',
        ordersWithoutInvoiceFetchOrders: 'Commandes seulement',
        ordersWithoutInvoiceFetchShifts: 'Quarts seulement',
        ordersWithoutInvoiceNeedDates: 'Veuillez indiquer une date de début et une date de fin.',
        ordersWithoutInvoiceSearch: 'Rechercher',
        ordersWithoutInvoiceSearching: 'Recherche…',
        ordersWithoutInvoiceSummaryOrders: 'Commandes',
        ordersWithoutInvoiceSummaryMerchants: 'Commerces',
        ordersWithoutInvoiceEmpty: 'Aucune commande non facturée pour cette période.',
        ordersWithoutInvoiceSelectAll: 'Tout sélectionner',
        ordersWithoutInvoiceColOrid: 'ORID',
        ordersWithoutInvoiceColMerchant: 'Commerce',
        ordersWithoutInvoiceColStatus: 'Statut',
        ordersWithoutInvoiceColScheduled: 'Planifiée',
        ordersWithoutInvoiceColDelivered: 'Livrée',
        ordersWithoutInvoiceColCommission: 'Commission km',
        ordersWithoutInvoiceColDestination: 'Destination',
        ordersWithoutInvoiceNothingSelected: 'Sélectionnez des commandes ou des quarts à facturer.',
        ordersWithoutInvoiceSelected: '{{orderCount}} commande(s), {{shiftCount}} quart(s) sélectionné(s)',
        ordersWithoutInvoiceSubmit: 'Générer les factures',
        ordersWithoutInvoiceConfirm: 'Créer des factures pour {{orderCount}} commande(s) et {{shiftCount}} quart(s) sélectionné(s) ?',
        ordersWithoutInvoiceSuccess: '{{orderInvoices}} facture(s) commandes ({{items}} ligne(s) de rapport), {{shiftInvoices}} facture(s) quarts ({{shiftItems}} ligne(s)). MIID : {{miids}}',
        invoiceThisOrder: 'Facturer cette commande',
        invoiceThisOrderConfirm: 'Générer une facture pour cette commande ?',
        invoiceThisOrderSuccess: 'Facture #{{miid}} créée.',
        invoiceThisOrderFailed: 'Impossible de générer la facture.',
        invoiceThisOrderView: 'Voir la facture #{{miid}}',
        shiftsWithoutInvoiceTitle: 'Quarts non facturés',
        shiftsWithoutInvoiceEmpty: 'Aucun quart d’horaire non facturé pour cette période.',
        shiftsWithoutInvoiceSummaryShifts: 'Quarts',
        shiftsWithoutInvoiceSummaryAmount: 'Montant',
        shiftsWithoutInvoiceSelectAll: 'Tout sélectionner (quarts)',
        shiftsWithoutInvoiceColShiftid: 'SHIFTID',
        shiftsWithoutInvoiceColDate: 'Date',
        shiftsWithoutInvoiceColDriver: 'Livreur',
        shiftsWithoutInvoiceColHours: 'Heures',
        shiftsWithoutInvoiceColAmount: 'Montant',
        allMerchants: 'Tous les commerces',
        payrollAlreadyGenerated: 'Attention! Les payes ont déjà été générées pour cette période. Souhaitez-vous les re-générer?',
        confirmDeleteReports: 'Êtes-vous sûr de vouloir supprimer ces rapports?',
        numberOfReceived: 'Nb reçus',
        tips: 'Pourboires',
        amountOwed: 'Montant dûs',
        amountToRefund: 'Montant à rembourser',
        adminFees: 'Frais admin',
        gstFees: 'TPS frais',
        taxes: 'Taxes',
        qstFees: 'TVQ frais',
        commissions: 'Commissions',
        grandTotal: 'Grand Total',
        additionalDetails: 'Détails additionnels',
        routesTotal: 'Routes Total',
        driverCommission: 'Driver Commission',
        bonuses: 'Bonuses',
        guarantees: 'Guarantees',
        reportNumber: '# Rapport',
        totalTest: 'Total Test',
        fees: 'Frais',
        regenerate: 'Re-générer',
        exportACH: 'Exporter ACH',
        receipt: 'Reçu',
        generatePayroll: 'Générer les payes',
        generatePayrollCanClose: 'Vous pouvez fermer cette fenêtre. La génération des payes continuera en arrière-plan.',
        generatePayrollCompleted: 'La génération des payes est terminée avec succès.',
        generatePayrollFailed: 'La génération des payes a échoué.',
        generatePayrollStatus: {
            queued: 'En attente',
            processing: 'En traitement',
            completed: 'Terminé',
            failed: 'Échec',
        },
        completeRequiredFields: 'Veuillez remplir tous les champs obligatoires',
        specifyPeriod: 'Veuillez préciser la période (date de début et de fin)',
    },
    billing: {
        paymentProblem: 'Problème de paiement: ',
        choosePaymentMethod: 'Choisissez votre méthode de paiement:',
        payWithSavedCard: 'Payer avec la carte de crédit enregistrée',
        payWithNewCard: 'Payer avec une nouvelle carte de crédit',
        confirmPaymentWithSavedCard: 'Confirmez le paiement avec votre carte enregistrée',
        confirmPayment: 'Confirmer le paiement',
        selectedInvoicesCount: 'Nombre de factures sélectionnées:',
        totalNetAmount: 'Montant total net:',
        total: 'Total',
        notPaid: 'Pas payé',
        paid: 'Payé',
        canceled: 'Annulé',
        period: 'Période',
        to: 'au',
        paymentMethod: 'Méthode de paiement',
        addPaymentMethod: 'Ajouter une méthode de paiement:',
        bankingOption: 'Spécimen chèque / Dépôt bancaire',
        creditOption: 'Carte de crédit',
        registeredPaymentMethod: 'Méthode de paiement enregistrée:',
        bankingSpecimen: 'Spécimen chèque',
        creditCard: 'Carte de crédit',
        change: 'Modifier',
        changePaymentMethod: 'Changer la méthode de paiement',
        selectPaymentMethod: 'Sélectionnez une méthode de paiement:',
        creditPayment: 'Paiement par carte de crédit',
        fetchError: 'Échec de la récupération de la méthode de paiement.',
        transitNumber: 'Numéro de transit',
        institutionNumber: 'Numéro d\'institution',
        accountNumber: 'Numéro de compte',
        customerNumber: 'Numéro de client',
        pleaseIndicateTransit: 'Veuillez indiquer votre numero de transit',
        pleaseIndicateInstitution: 'Veuillez indiquer votre numero institution',
        pleaseIndicateAccount: 'Veuillez indiquer votre numéro de compte',
        pleaseIndicateCustomer: 'Veuillez indiquer le numero de client',
        send: 'Envoyer',
        voidChequeInfo: 'Vous trouverez les informations nécessaire sur un chèque annulé, pouvant être fourni par votre banque.',
        voidChequeAlt: 'Chèque annulé',
        cardNumber: 'Numéro de carte',
        cardNumberRequired: 'Le numéro de carte est requis.',
        cardNumberInvalid: 'Ce numéro de carte semble invalide.',
        expiration: 'Expiration',
        expirationRequired: 'La date d\'expiration est requise.',
        expirationInvalid: 'Cette date d\'expiration semble invalide.',
        cvv: 'CVV',
        cvvRequired: 'Le code de sécurité est requis.',
        cvvInvalid: 'Ce code de sécurité semble invalide.',
        cardholderName: 'Nom sur la carte',
        cardholderNameRequired: 'Le nom sur la carte est requis.',
        cardholderNameInvalid: 'Le nom est requis',
        saveCardForFuture: 'Enregistrer la carte pour les paiements futurs',
        payNow: 'Payer maintenant',
        save: 'Enregistrer'
    },
    reports: {
        orders: 'Commandes',
        kpi: 'KPI',
        data: 'Données',
        nbOrders: 'Nb de commandes',
        numberOfOrders: 'Nb de commandes',
        totalMerchantCommissions: 'Commissions totales commerce',
        totalDriverCommissions: 'Commissions totales livreurs',
        tips: 'Pourboires',
        nbCancelledOrders: 'Nb de commandes annulées',
        averageDeliveryTime: 'Temps livraison moyen',
        averageDistance: 'Distance moyenne',
        averageInvoice: 'Facture moyenne',
        percentageDelivery: 'Livraison à temps',
        showPaymentMethod: 'Afficher détails mode de paiement',
        paiementMethod: {
            debit: 'debit',
            credit: 'Crédit',
            cash: 'Cash'
        },
        convertion: {
            machineToComptant: 'Machine -> Comptant:',
            cashToDebit: 'Comptant -> Débit:',
            cashToCredit: 'Comptant -> Crédit:'
        },
        customDisplay: {
            orderTotal: 'commandes, total:'
        },
        date: 'Date',
        deliveredTo: 'Livré à',
        address: 'Adresse',
        client: 'Client',
        driver: 'Livreur',
        deliveredByGoLivro: '(Livré par GO LIVRO)',
        noDriver: 'Aucun livreur',
        paymentMethod: 'Mode de paiement',
        tip: 'Tip',
        start: 'Début',
        startTime: 'Début (heure)',
        end: 'Fin',
        endTime: 'Fin (heure)',
        deliveryProof: 'Preuve de livraison',
        guarantees: 'Garanties',
        nbDriversWithGuarantees: 'Nb de livreurs à guaranties',
        drivers: 'Livreurs',
        nbWorkedHours: 'Nb d\'heures travaillées',
        nbGuarantees: 'Nb de guaranties',
        totalDriverCommissions: 'Commissions totales livreurs',
        bonuses: 'Bonus',
        nbBonuses: 'Nb de Bonus',
    },
    auth: {
        login: 'Connexion',
        email: 'Courriel',
        password: 'Mot de passe',
        rememberMe: 'Se souvenir de moi',
        forgotPassword: 'Mot de passe oublié?',
        createAccount: 'Créer un compte',
        forgotPasswordTitle: 'Mot de passe oublié',
        resetPassword: 'Réinitialiser le mot de passe',
        registerDispatch: 'Inscription entreprise de courrier',
    },
    validation: {
        required: 'Le champ :attribute est requis.',
        tryLater: 'Veuillez réessayer plus tard',
        proceedConfirmation: 'Êtes-vous sûr de vouloir fermer cette route ? Les livraisons en cours seront marquées comme complétées.',
        deleteDriver: 'Êtes-vous sûr de vouloir supprimer ce livreur?',
        deleteAddresse: 'Êtes-vous sûr de vouloir supprimer cette adresse?',
        enterDriverName: 'Veuillez indiquer le nom du livreur',
        enterDriverEmail: 'Veuillez indiquer le courriel du livreur',
        enterDriverPhone: 'Veuillez indiquer le numéro de téléphone du livreur',
        enterPassword: 'Veuillez indiquer le mot de passe',
        enterMerchantName: 'Veuillez indiquer le nom du commerce',
        enterMerchantPhone: 'Veuillez indiquer le numéro de téléphone du commerce',
        enterAddress: 'Veuillez indiquer l\'adresse',
        enterPhoneOrName: 'Veuillez indiquer au moins le nom ou un numéro de téléphone',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer?',
        enterName: 'Veuillez indiquer le nom',
        enterEmail: 'Veuillez indiquer le courriel',
        enterInteger: 'Entrez un nombre entier',
        shiftForm: {
            selectWeekDay: 'Veuillez sélectionner un jour de la semaine',
            selectStartTime: 'Veuillez indiquer l\'heure de début',
            selectEndTime: 'Veuillez indiquer l\'heure de fin',
            shiftInPast: 'Il n\'est pas possible de créer ou de modifier un shift dans le passé.',
            invalidHours: 'L\'heure de fin doit être après l\'heure de début, le même jour.',
            shiftDeletionPastError: '* Il n\'est pas possible de supprimer un shift qui a déjà eu lieu.',
        },
        shiftDeletionPastInfo: '* Vous pouvez cependant supprimer les shifts pour les prochaines semaines.',
        scheduleForm: {
            selectAtLeastOneTimeSlot: 'Veuillez ajouter au moins une plage',
        },
        chooseAddressOrPhoneNumber: 'Veuillez choisir une adresse ou un numéro de téléphone',
        chooseAddress: 'Veuillez choisir une adresse',
        chooseMerchant: 'Veuillez choisir un marchand parmi la liste',
        choosePackageSize: 'Veuillez choisir une grandeur de colis',
        chooseService: 'Veuillez choisir un service',
        specifyPickupTime: 'Veuillez spécifier l\'heure de ramassage',
        pickupTimeRange: 'L\'heure de ramassage doit être entre 9h et 20h',
        specifyDeliveryDeadline: 'Veuillez spécifier une heure limite de livraison',
        specifyPickupDeadline: 'Veuillez spécifier une heure limite de ramassage',
        invalidPhone: 'Le numéro de téléphone doit contenir 10 chiffres (########## ou ###-###-####).',
    },
    tracking: {
        title: 'Suivi de livraison',
    },
    common: {
        bulkUnassign: 'Désassigner les livraisons',
        bulkCancel: 'Annuler les livraisons',
        bulkComplete: 'Compléter les livraisons',
        tryAgain: 'Réessayer',
        failedToLoad: 'Échec du chargement',
        notFound: 'Non trouvé',
        nA: 'N/A',
        weekly: 'HEBDOMADAIRE',
        biweekly: '2 SEMAINES',
        monthly: 'MENSUEL',
        selection: 'Sélection',
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        search: 'Recherche',
        actions: 'Actions',
        back: 'Retour',
        cancel: 'Annuler',
        continue: 'Continuer',
        yes: 'Oui',
        no: 'Non',
        loading: 'Chargement...',
        submitting: 'Envoi…',
        changePaymentMethod: 'Changer de méthode de paiement',
        fetchPaymentMethodError: 'Échec de la récupération de la méthode de paiement.',
        genericError: 'Une erreur est survenue, réessayez plus tard',
        drivers: 'Livreurs',
        warnings: 'Avertissements',
        optimizeRoute: 'Générer des routes',
        mergePickups: 'Fusionner les ramassages',
        ignoreTimeWindows: 'Ignorer les fenêtres de temps',
        withoutDriversSuggestion: 'Sans chauffeurs',
        chooseNbDrivers: 'Choisir le nombre de chauffeurs',
        maxRouteDuration: 'Temps max par route',
        hoursShort: 'h',
        generateRoutes: 'Générer les itinéraires pour',
        generateRoutesButton: 'Générer des routes',
        addTransit: 'Ajouter un transit',
        pickupProblem: 'Problème de ramassage',
        deliveryProblem: 'Échec de livraison',
        addTransitInfoStorage: 'Ce formulaire sert au dépôt temporaire en point de transit (entreposage).',
        addTransitInfoDeposit: 'Le chauffeur dépose les colis; un autre ramassage sera planifié plus tard.',
        addTransitInfoSplitInstead: 'Si le chauffeur conserve les colis avec lui, utilisez plutôt',
        splitPickupDelivery: 'Séparer le ramassage/livraison',
        splitPickupDeliveryAlreadySplit: 'Cette livraison est déjà séparée (ramassage ou livraison seulement).',
        splitPickupDeliveryAlreadySplitBulk: 'Ces livraisons sont déjà séparées (ramassage ou livraison seulement).',
        splitPickupDeliveryAlreadySplitIgnored: '{count} livraison(s) déjà séparée(s) seront ignorée(s).',
        reunitePickupDelivery: 'Réunir le ramassage/livraison',
        reunitePickupDeliveryBulkTitle: 'Réunir le ramassage/livraison ({count} livraisons)',
        reunitePickupDeliverySubmit: 'Réunir',
        reunitePickupDeliverySubmitCount: 'Réunir ({count})',
        reunitePickupDeliveryInfoKeep: 'Une seule livraison sera conservée; la 2e livraison sera retirée.',
        reunitePickupDeliveryInfoBeforePickup: 'Si le ramassage n\'est pas fait, le stop de livraison revient sur la route actuelle.',
        reunitePickupDeliveryInfoAfterPickup: 'Si le ramassage est déjà fait, il reste complété; seule la livraison est rétablie.',
        reunitePickupDeliveryBlocked: 'Impossible de réunir : ce n\'est pas un ramassage/livraison séparé, ou la livraison est déjà complétée ou annulée.',
        reunitePickupDeliveryNone: 'Aucune livraison séparée à réunir.',
        reunitePickupDeliveryNoneBulk: 'Aucune de ces livraisons ne peut être réunie.',
        reunitePickupDeliveryIgnored: '{count} livraison(s) non séparée(s) ou déjà complétée(s) seront ignorée(s).',
        reunitePickupDeliveryNoDelivery: 'Aucune livraison active trouvée.',
        reunitePickupDeliveryError: 'Une erreur est survenue',
        parentLegIncomplete: "Attention : le ramassage/segment précédent n'est pas encore complété.",
        selectedOrders: 'commandes sélectionnées',
        timeWindowsIgnored: {
            title: 'Les fenêtres de temps ont été ignorées',
            description: 'Il est impossible de livrer toutes les commandes en respectant leurs fenêtres de temps tout en fusionnant les ramassages pour les commandes sélectionnées.',
            descriptionSimple: 'Certaines commandes ne peuvent pas être livrées dans leurs fenêtres de temps.'
        },
        timeWindowsViolation: {
            title: 'Les commandes suivantes ne respectent pas leur fenêtre de temps :'
        },
        labels: {
            distance: 'Distance',
            duration: 'Durée',
            km: 'KM'
        },
        confirmRemoveRoute: 'Êtes-vous sûr de vouloir supprimer cette route ? Les commandes seront remises dans la liste des commandes non assignées.',
        confirmAcceptRoute: 'Êtes-vous sûr de vouloir générer cette route ?',
        confirmAcceptAllRoutes: 'Êtes-vous sûr de vouloir générer {count} route(s) ?',
        acceptingRoutes: 'Acceptation...',
        acceptRoute: 'Accepter la route',
        removeRoute: 'Supprimer la route',
        acceptRoutes: 'Accepter les routes',
        noDriver: 'Non assigné',
        headers: {
            price: 'Prix',
            itinerary: 'Itinéraire',
            completedStops: 'Arrêts complétés',
            distance: 'Distance',
            duration: 'Durée',
            driver: 'Chauffeur',
            actions: 'Actions',
            commerce: 'Commerce',
            address: 'Adresse',
            openingTime: "Heure d'ouverture",
            closureTime: 'Heure de fermeture',
            day: 'Jour'
        },
        allOrdersAssigned: 'Toutes les commandes sont assignées',
        noUnassignedOrders: 'Aucune commande non assignée',
        unassignedOrders: 'Commandes sans itinéraire',
        unassignedOrdersSubtitle: 'Ces commandes ne sont pas assignées à un itinéraire',
        actions: {
            filter: 'Filtrer',
            clear: 'Effacer',
            add: 'Ajouter',
            cancel: 'Annuler',
            modify: 'Modifier',
            delete: 'Supprimer',
            save: 'Enregistrer',
            confirm: 'Confirmer',
            next: 'Suivant',
            return: 'Retour',
            selectRole: 'Sélectionner un rôle',
            useDifferentOrigine: 'Modifier l\'adresse de ramassage',
            useSameOrigine: 'Utiliser l\'adresse de mon commerce',
            deleteShift: 'Supprimer ce shift',
            optimizeRoute: 'Optimiser la route',
            reoptimizeFullRoute: 'Réoptimiser toute la route',
            mergePickups: 'Fusionner les ramassages',
            ignoreTimeWindows: 'Ignorer les fenêtres de temps',
            selectStartPoint: 'Ajouter un point de départ',
            removeStartPoint: 'Retirer le point de départ'
        },
        orderFees: {
            addExtraFee: 'Ajouter un frais',
            additionalFee: 'Frais supplémentaire',
            amountLabel: 'Montant',
            appliesToDelivery: "S'applique à la livraison",
            baseCommission: 'Commission de base',
            billedToMerchantAndGivenToDriver: 'Facturé au commerce et remis au livreur',
            bonus: 'Bonus',
            cannotRetrieveFees: 'Impossible de retrouver les frais de cette commande, réessayez plus tard',
            chooseBonus: 'Choisir un bonus',
            chargeOrderAnyway: 'Facturer quand même',
            chargeOrderAnywayHelp: 'Inclure cette commande annulée dans la facture du commerce.',
            confirmRefund: 'Êtes-vous sûr de vouloir rembourser ce client?',
            customFee: 'Frais personnalisé',
            customFeeLabel: 'Libellé du frais personnalisé',
            customFeeLabelRequired: 'Le libellé est requis pour un frais personnalisé.',
            driver: 'Livreur',
            driverSharePct: 'Part livreur %',
            extraFees: 'Frais supplémentaires',
            fixedFee: 'Frais fixe',
            internalFee: 'Frais interne',
            merchant: 'Commerce',
            minutesWaited: 'Minutes d\'attente',
            otherOption: 'Autre',
            otherReason: 'Motif de ce frais',
            percentageOnInvoiceAmount: '% sur le montant de la facture',
            refundClient: 'Rembourser le client',
            totalDriver: 'Total livreur',
            totalMerchant: 'Total commerce',
            typeLabel: 'Type',
            waitingFee: "Frais d'attente"
        },
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        messages: {
            savedSuccessfully: 'Modifications enregistrées avec succès'
        },
        businessHours: {
            title: "Heures d'ouverture du commerce",
            enableBusinessHours: "Définir les heures d'ouverture (optionnel)",
            optionalNote: "Les heures d'ouverture sont optionnelles. Activez cette option pour définir les heures d'ouverture de votre commerce.",
            serviceFlexible: 'Flexible',
            serviceEntreprise: 'Entreprise',
            servicePonctuel: 'Ponctuel',
            serviceDirect: 'Direct',
            serviceUnavailable: 'Le service {{services}} ne sera pas disponible pour cette date selon les heures d\'ouverture du commerce.',
            sameForAllDays: "Utiliser les mêmes heures pour tous les jours",
            closed: 'Le commerce est fermé ce jour.',
            openingHoursForDay: 'Les heures d\'ouverture pour ce jour sont de {{openingTime}} à {{closureTime}}.',
            modifyHoursInSettings: 'Vous pouvez modifier les heures d\'ouverture dans les paramètres du commerce.',
            modifyHours: "Modifier les heures d'ouverture",
            removeStartPoint: 'Retirer le point de départ',
            confirm: 'Confirmer',
            save: 'Enregistrer',
            modify: 'Modifier',
            add: 'Ajouter',
            delete: 'Supprimer',
            deleteShift: 'Supprimer ce shift',
            return: 'Retour',
            next: 'Suivant',
            filter: 'Filtrer',
            selectRole: 'Sélectionner un rôle',
            useDifferentOrigine: 'Modifier l\'adresse de ramassage',
            useSameOrigine: 'Utiliser l\'adresse de mon commerce'
        },
        billing: {
            addPaymentMethodRequired: 'Veuillez ajouter une méthode de paiement pour continuer.',
            addPaymentMethod: 'Ajouter une méthode de paiement',
            outstandingBalanceWarning: 'Votre compte pourrait être suspendu si aucun paiement n\'est reçu.',
            outstandingBalanceWarningDetailed: 'ATTENTION ! Vous avez un solde de {{amount}}$ impayé en retard de plus de {{days}} jours.\n\nLe service pourrait être suspendu prochainement.\nMerci d\'effectuer le paiement.',
            accountSuspendedOutstandingBalance: 'Votre compte est suspendu en raison d\'un solde impayé. Veuillez effectuer un paiement pour continuer.',
            accountSuspendedOutstandingBalanceDetailed: 'ATTENTION ! Votre compte est suspendu. Vous avez un solde de {{amount}}$ impayé en retard de plus de {{days}} jours.\n\nMerci d\'effectuer le paiement pour rétablir le service.',
            goToBilling: 'Accéder à la facturation',
            viewAndPayInvoices: 'Voir et payer factures',
        },
        shiftForm: {
            deleteShiftAndWeeks: 'Supprimer ce shift et les semaines prochaines',
            deleteWeeksKeepShift: 'Supprimer les semaines prochaines et conserver ce shift',
            taskDescription: 'Description des tâches / Prérequis',
            comments: 'Commentaires',
            recurringShift: 'Shift récurrent (se répète chaque semaine)',
            hourlyFee: 'Tarif horaire',
            estimatedDuration: 'Durée estimée',
            estimatedTotal: 'Total estimé',
            pricingPending: 'Indiquez l\'heure de début et de fin pour voir le total estimé.',
            estimatedTotalHint: 'Estimation avant taxes, selon la durée prévue et votre tarif horaire. La facture suit les heures confirmées.',
            confirmEstimateHint: 'Estimation avant taxes, selon les heures à confirmer.',
            perOccurrence: 'Ce montant s\'applique à chaque occurrence hebdomadaire.',
            pricingUnavailable: 'Impossible de charger le tarif horaire. Réessayez plus tard.',
            dayOfWeek: 'Jour de la semaine',
            chooseDayOfWeek: 'Choisir un jour de la semaine'
        },
        scheduleForm: {
            addTimeSlot: 'Ajouter une plage'
        },
        headers: {
            commerce: 'Commerce',
            day: 'Jour',
            openingTime: "Heure d'ouverture",
            closureTime: 'Heure de fermeture',
            startTime: 'Heure de début',
            endTime: 'Heure de fin',
            timeSlotsList: 'Liste des plages horaires',
            actions: 'Actions',
            search: 'Recherche',
            name: 'Nom',
            phoneNumber: 'Numéro de téléphone',
            billingEmail: 'Courriel de facturation',
            address: 'Adresse',
            city: 'Ville',
            postalCode: 'Code Postal',
            delayByDefault: 'Délai par défaut (h)',
            tackingBySMS: 'Tracking par SMS',
            proofRequired: 'Preuves livros obligatoire',
            price: 'Prix',
            distance: 'Distance',
            date: 'Date',
            ordersOrder: 'Ordre des commandes',
            oldPassword: 'Ancien mot de passe',
            newPassword: 'Nouveau mot de passe',
            confirmNewPassword: 'Confirmer le nouveau mot de passe',
            actions: 'Actions',
            noResult: 'Aucun résultats',
            noActiveDriver: 'Aucun livreur actif',
            noDriver: 'Aucun livreur',
            busyDrivers: 'Livreurs occupés',
            offlineShiftDrivers: 'Hors ligne — quart compatible',
            noOfflineShiftDriver: 'Aucun livreur hors ligne avec un quart couvrant cette route',
            upcomingShiftDrivers: 'Quarts à venir',
            noUpcomingShiftDriver: 'Aucun livreur avec un quart bientôt',
            delete: 'Supprimer',
            deliveryComment: 'Commentaire livraison'
        },
        pagination: {
            previous: 'Précédent',
            next: 'Suivant',
            range: '{start} à {end}',
            items: 'éléments',
            selected: 'sélectionné(s)'
        },
        emailPreferences: 'Préférences de courriel',
        preference: 'Préférence',
        copy: 'Copier',
        changesSaved: 'Les changements ont bien été enregistrés',
        saveChanges: 'Sauvegarder les changements',
        seeMore: 'Voir plus',
        phoneNumber: 'Numéro de téléphone',
        email: 'Courriel',
        address: 'Adresse',
        date: 'Date',
        status: 'Statut',
        amount: 'Montant',
        filters: {
            start: 'Début',
            end: 'Fin'
        },
        glossary: {
            merchant: 'Commerce'
        },
        originPickupInputs: {
            comment: 'Commentaire pour le ramassage',
            name: 'Nom de l\'entreprise',
            nameHint: 'Si vous n\'expédiez pas pour une entreprise, inscrivez votre nom.',
            address: 'Adresse de ramassage',
            phone: '# de téléphone',
            apartment: 'Appartement'
        },
        addressForm: {
            pickupQuestion: 'Quelle est l\'adresse de ramassage?',
            destinationQuestion: 'On ship ça où?',
            addDestination: 'Ajouter une adresse',
            businessDiscountTitle: 'Profitez d\'escomptes pour les entreprises',
            businessDiscountSubtitle: 'Votre entreprise expédie plusieurs colis par jour? Optez pour un forfait sur mesure.',
            createAccount: 'Créer un compte',
            login: 'Connexion',
            dedicatedIllustrationAlt: 'Illustration d\'un service de livraison dédié'
        },
        updateRoutePayment: {
            title: 'Modifier le paiement de la route',
            routeLabel: 'Route #{routeId}',
            noDriver: 'Aucun livreur assigné',
            inputLabel: 'Paiement livreur ($)',
            inputPlaceholder: '0,00',
            save: 'Sauvegarder',
            estimate: 'Estimer',
            cancel: 'Annuler',
            error: 'Échec de la mise à jour du paiement'
        },
        addOrderToRoute: {
            selectRouteTitle: 'Sélectionner une route',
            unassignedTitle: 'Routes non assignées',
            assignedTitle: 'Routes assignées',
            noRoutes: 'Aucune route',
            noUnassignedRoutes: 'Aucune route non assignée',
            noAssignedRoutes: 'Aucune route assignée',
            selectRouteAria: 'Sélectionner cette route'
        },
        routeMaker: {
            ordersOrder: 'Ordre des commandes',
            generateRoute: 'Générer la route',
            roadComment: 'Commentaire pour la route',
            roadScheduled: 'Heure prévue',
        },
        pickupDetails: {
            title: 'Détail du ramassage',
            notifEmailConsignee: 'Envoyer les mises à jour de statut au destinataire par courriel',
            notifEmailSender: 'Envoyer les mises à jour de statut à l’expéditeur par courriel',
            consigneeEmail: 'Courriel du destinataire (suivi)',
            additionalOptionsTitle: 'Presque prêt! Avant de partir, besoin d\'autre chose?',
            useSMS: 'Envoyer le suivi GPS au destinataire par SMS',
            useSignature: 'Signature requise à la livraison',
            usePOS: 'Percevoir un montant au destinataire',
            useTip: 'Pourboire au livreur'
        },
        inputs: {
            Address: 'Adresse',
            destinationAddress: 'Adresse de destination',
            enterAddress: 'Entrez l\'adresse',
            enterPhoneNumber: 'Entrez le # de téléphone',
            enterPhoneOrName: 'Téléphone ou nom',
            searchSavedDestination: 'Rechercher une adresse enregistrée',
            searchSavedDestinationPlaceholder: 'Nom, téléphone ou adresse',
            searchSavedDestinationHint: 'Rechercher dans vos adresses enregistrées (nom, téléphone, adresse, ville, code postal)',
            orEnterNewAddress: 'Ou saisir une nouvelle adresse',
            addressNotFound: 'Adresse introuvable ?',
            automaticEntry: 'Saisie automatique',
            incompletePostalCode: 'Le code postal est incomplet. Complétez-le avant de passer à l\'étape suivante.',
            streetNumber: 'Numéro de rue',
            street: 'Rue',
            postalCode: 'Code postal',
            city: 'Ville',
            searchAddress: 'Rechercher',
            phoneNumber: 'Numéro de téléphone',
            andOrAddress: 'et/ou l\'adresse',
            apartmentNumber: 'Numéro d\'appartement',
            deliveryComments: 'Commentaire livraison',
            clientName: 'Nom du client',
            recipientName: 'Nom du destinataire',
            recipientNameorCorporation: 'Nom du destinataire ou l\'entreprise',
            aboutDestinationComments: 'Commentaire par rapport au destinataire',
            firstname: 'Prénom',
            email: 'Courriel',
            role: 'Rôle',
            tmpPassword: 'Mot de passe temporaire',
            confirmPassword: 'Confirmer le mot de passe'
        },
        questions: {
            apartmentNumber: 'Numéro d\'appartement'
        },
        destinationOptions: {
            sendGPSTrackingSMS: 'Envoyer suivi GPS au client par SMS',
            proofRequired: 'Preuve de livraison obligatoire',
            signatureRequired: 'Signature obligatoire',
            collectAmount: 'Percevoir un montant',
            tipToDriver: 'Pourboire au livreur',
            amountToCollect: 'Montant à récolter',
            amountToCollectPlaceholder: 'Montant à récolter ($)',
            posPaymentDescription: 'Paiement sans contact uniquement (Tap, Apple Pay, Google Pay). L’insertion de carte et le NIP ne sont pas pris en charge.',
            posPaymentPolicyLink: 'Lire la politique de collecte de paiement à la porte',
            tipAmount: 'Montant du pourboire',
            tipAmountPlaceholder: 'Montant du pourboire $'
        },
        orderForm: {
            nextStep: 'Étape suivante',
            confirmAndPay: 'Confirmer et payer',
            cannotProvideService: 'Nous ne pouvons pas fournir le service actuellement, réessayez plus tard.',
            serviceNotAvailable: 'Nos services ne sont pas actuellement disponible à votre adresse.',
            packageWeightExceeded:
                'Le poids du colis dépasse la limite acceptée (max {{maxKg}} kg / {{maxLbs}} lbs). Veuillez réduire le poids pour obtenir un prix.',
            invalidPromoCode: 'Code promo invalide',
            promoValidationError: 'Erreur lors de la validation du code promo',
            choosePickupAndDestination: 'Veuillez choisir une adresse de ramassage et de destination parmi la liste déroulante.',
            specifyAllFields: 'Veuillez spécifiez tous les champs munis d\'un astérix "*".',
            orderAddedSuccess: 'Commande ajoutée avec succès !',
            shipmentCreatedTitle: 'Envoi planifié',
            shipmentCreatedPickupSubheading: 'Cueillette planifiée le {{window}}',
            shipmentCreatedPickupSubheadingWithCarrier: 'Cueillette effectuée par {{carrier}} le {{window}}',
            summaryEmailSent: 'Un résumé de votre livraison vous sera envoyé par courriel sous peu.',
            trackingNumber: 'Numéro de suivi',
            onlineTracking: 'Suivi en ligne',
            printLabelMandatoryPrefix: 'Obligatoire - ',
            printLabelOptionalPrefix: 'Optionnel - ',
            printLabelImportant:
                "Imprimez l'étiquette d'expédition et fixez-la à votre colis avant le ramassage.",
            printLabel: 'Imprimer l\'étiquette',
            printLabelHint: 'Imprimez votre étiquette ici ou plus tard dans l\'historique des commandes.',
            printLabelLater: 'Imprimer plus tard',
            printLabelDeferModalTitle: 'Recevoir le lien d\'impression',
            printLabelDeferIntro:
                'Envoyez-vous le lien pour imprimer l\'étiquette d\'expédition par courriel ou par texto (frais du transporteur / opérateur peuvent s\'appliquer au SMS).',
            printLabelDeferChannelLabel: 'Méthode',
            printLabelDeferChannelEmail: 'Courriel',
            printLabelDeferChannelSms: 'SMS',
            printLabelDeferPhoneLabel: 'Numéro de téléphone',
            printLabelDeferPhonePlaceholder: 'Ex. 514 555 0123',
            printLabelDeferEmailLabel: 'Adresse courriel',
            printLabelDeferEmailPlaceholder: 'vous@exemple.com',
            printLabelDeferSubmit: 'Envoyer',
            printLabelDeferSuccess: 'Envoyé.',
            printLabelDeferError: 'L\'envoi a échoué. Réessayez.',
            printLabelDeferInvalidLink: 'Lien d\'impression invalide.',
            trackOnline: 'Suivre l\'envoi',
            referenceNumber: 'Numéro de référence',
            trackOnlineHint: 'Ouvrez la page de suivi du transporteur pour les mises à jour.',
            nextStepsTitle: "Ce n'est pas terminé, voilà les prochaines étapes…",
            temporaryPasswordTitle: 'Mot de passe temporaire',
            temporaryPasswordPortal:
                'Connectez-vous à votre espace client avec ce mot de passe pour consulter l\'historique d\'envois et les rabais volume.',
            loginToPortal: 'Connexion à l\'espace client',
            copyPassword: 'Copier',
            passwordCopied: 'Copié',
            shipmentSuccessDone: 'Terminé',
            merchantDashboardLink: 'Ouvrir l\'espace commerçant',
            whenDoYouNeed: 'Besoin que ca parte quand?',
            summaryPickupWindowLabel: 'Ramassage',
            summaryDeliveryLabel: 'Livraison',
            summaryPickupDateTimeSeparator: '·',
            summaryDeliveryBeforeTime: 'Avant {{time}}',
            summaryScheduleLaterNotice:
                'A planifier plus tard sur votre espace client, un mot de passe temporaire vous sera envoyé par courriel',
        },
        payment: 'Paiement',
        now: 'Maintenant',
        plan: 'Planifier',
        atMerchant: 'Au commerce',
        atClient: 'Chez le client',
        paymentMethod: 'Mode de paiement',
        paymentMethods: {
            alreadyPaid: 'Déjà payé',
            cash: 'Cash',
            debit: 'Debit',
            credit: 'Credit'
        },
        paymentTypeForm: {
            title: 'Mode de paiement',
            alreadyPaid: 'Déjà payé',
            cash: 'Cash',
            debit: 'Debit',
            credit: 'Credit',
            POSComptant: 'POS-Comptant',
            comptantDebit: 'Comptant-Debit',
            comptantCredit: 'Comptant-Credit',
            invoiceAmount: 'Montant de la facture',
            tip: 'Pourboire',
            alreadyPaidHelp: 'Aucun paiement ne doit être perçu, ou le commerce s\’est directement arrangé avec le livreur pour le paiement.',
            cashHelp: 'Le client paie comptant et le livreur conserve l\'argent avec lui',
            debitHelp: 'Le client paie par carte débit',
            creditHelp: 'Le client paie par carte crédit'
        },
        invoiceAmount: 'Montant de la facture',
        time: 'Heure',
        optional: 'Optionnel',
        packageCount: 'Nombre de colis',
        content: 'Contenu',
        whatAreWeSending: 'Qu\'est-ce qu\'on envoie?',
        moreInfoOnFormats: 'Plus d\'infos sur les formats',
        bubbleContent: {
            approximateSize: 'Taille approximative',
            examples: 'Exemples',
            small: {
                title: 'Enveloppe',
                transportMethod: 'Tient dans une main',
                maxSpecMetric: 'Jusqu\'à ~ 30cm et 1kg',
                maxSpecImperial: '~ 12po et 2lbs',
                sizeDescription: 'Jusqu\'à ~ 30cm et 1kg ~ 12po et 2lbs',
                examples: 'Ex : courrier, petit sac'
            },
            medium: {
                title: 'Colis',
                transportMethod: 'Se transporte à une main',
                maxSpecMetric: 'Jusqu\'à ~ 30cm et 5kg',
                maxSpecImperial: '~ 12po et 10lbs',
                sizeDescription: 'Jusqu\'à ~ 30cm et 5kg ~ 12po et 10lbs',
                examples: 'Ex : boite, gros sac, paquet'
            },
            large: {
                title: 'Large',
                transportMethod: 'Se transporte à deux mains',
                maxSpecMetric: 'Jusqu\'à ~ 1m et 20kg',
                maxSpecImperial: '~ 3pi et 45lbs',
                sizeDescription: 'Jusqu\'à ~ 1m et 20kg ~ 3pi et 45lbs',
                examples: 'Ex : grosse boite, petite meuble'
            },
            registered: {
                title: 'Courrier recommandé',
                transportMethod: 'Livré le jour même. Repérage en temps réel et délivrance d\'un récépissé à l\'expéditeur prouvant le dépôt et la remise contre signatures. Votre courrier vous est retourné si la remise au destinataire est impossible.',
                maxSpecMetric: 'Max. 2,5–4,5 kg',
                maxSpecImperial: 'Max. 5–10 lb',
                sizeDescription: 'Max. 5–10 lb (2,5–4,5 kg)',
                examples: 'Enveloppe / petit courrier avec signature',
                selectionNote: 'Signature obligatoire à la remise, sinon le colis vous est retourné.',
            }
        },
        packageDimensions: {
            title: 'Dimensions du colis',
            outsideServiceZone: 'Cette destination est hors de notre zone de service. Veuillez fournir les dimensions exactes du colis.',
            length: 'Longueur (cm)',
            width: 'Largeur (cm)',
            height: 'Hauteur (cm)',
            weight: 'Poids (kg)',
            lengthPlaceholder: 'Longueur en cm',
            widthPlaceholder: 'Largeur en cm',
            heightPlaceholder: 'Hauteur en cm',
            weightPlaceholder: 'Poids en kg',
            lengthIn: 'Longueur (po)',
            widthIn: 'Largeur (po)',
            heightIn: 'Hauteur (po)',
            weightLbs: 'Poids (lb)',
            lengthPlaceholderIn: 'Longueur en pouces',
            widthPlaceholderIn: 'Largeur en pouces',
            heightPlaceholderIn: 'Hauteur en pouces',
            weightPlaceholderLbs: 'Poids en lb',
            unitsLabel: 'Unités',
            unitsMetric: 'cm / kg',
            unitsImperial: 'po / lb',
            required: 'Toutes les dimensions sont requises pour la livraison étendue',
            packageNumberLabel: 'Colis',
            quantity: 'Quantité',
            distinctPackageTypes: 'Nombre de formats de colis différents',
            addPackageFormat: 'Ajouter un format',
            removePackageFormat: 'Retirer ce format',
            carrierModalTitle: 'Dimensions du colis',
            carrierModalIntro: 'Indiquez les dimensions exactes de chaque colis pour obtenir un tarif précis pour la livraison via un partenaire.',
            carrierModalConfirm: 'Confirmer et mettre à jour le prix',
            carrierModalValidation: 'Veuillez saisir la longueur, la largeur, la hauteur et le poids pour chaque colis.',
            calculatePrice: 'Calculer le prix',
            defaultsHeading: 'Dimensions de colis par défaut',
            defaultsHelp: 'Utilisées automatiquement lorsque des dimensions exactes sont requises.',
            defaultsIncomplete: 'Indiquez la longueur, la largeur, la hauteur et le poids, ou laissez tous les champs vides.',
            defaultsAutofilled: 'Valeurs remplies à partir de vos dimensions par défaut.',
            defaultsSettingsLink: 'Modifier les dimensions par défaut',
            shippingBoxesHeading: 'Boîtes d’expédition',
            shippingBoxesHelp: 'Ajoutez les boîtes que vous utilisez. La boîte par défaut est utilisée lorsque des dimensions exactes sont requises.',
            shippingBoxesEmpty: 'Ajoutez les boîtes que vous utilisez. La boîte par défaut sert aux commandes qui demandent des dimensions.',
            shippingBoxName: 'Nom de la boîte',
            shippingBoxMaxWeight: 'Poids max',
            shippingBoxEmptyWeight: 'Poids à vide (optionnel)',
            shippingBoxDefault: 'Par défaut',
            shippingBoxSetDefault: 'Définir par défaut',
            shippingBoxAdd: 'Ajouter une boîte',
            shippingBoxRemove: 'Retirer',
            shippingBoxIncomplete: 'Chaque boîte doit avoir un nom, une longueur, une largeur et une hauteur.',
            shippingBoxSkippedOnProfileSave: 'Profil enregistré. Complétez ou retirez les boîtes incomplètes pour les enregistrer aussi.',
            shippingBoxClearConfirm: 'Retirer toutes les boîtes d’expédition ? Les commandes n’auront plus de boîte par défaut.',
        },
        servicePart: {
            planForLaterDate: 'Planifiez pour une date ultérieure',
            planAndSave: 'Planifiez et économisez',
            startingFrom: 'À partir de',
            flexibleRateInfo: 'Pour bénéficier du tarif de livraison flexible le jour même, la livraison doit être envoyée avant 13h.',
            flexibleRateInfoOutsideZone: 'Notre service en 4h n\'est pas encore disponible à votre adresse. Toutefois, nous proposons un service express via notre réseau partenaire étendu.',
            service: 'Service',
            deliveryDate: 'Date de livraison',
            rate: 'Prix',
            choose: 'Choisir',
            deliveryServicesTitle: 'Services de livraison',
            seeShippingOptions: "Voir les options d'expédition",
            sortBy: 'Trier par :',
            daysUnit: 'jour(s)',
            deliveryDateToday: 'Aujourd\'hui',
            deliveryDateTomorrow: 'Demain',
            deliveryDateInDaysPrefix: 'D\'ici',
            deliveredPrefix: 'Livré',
            ishipExpress: 'L\'express',
            ishipEconomique: 'L\'économique',
            ishipExpressGaranti: 'L\'express garanti',
            posteCanadaNoPickup: 'Poste Canada',
            posteCanadaNoPickupLabel: '⚠️ Ramassage non inclus',
            posteCanadaDeliveryRange: '1 - 2 jours ouvrables',
            ishipExpressDeliveryRange: '1 jour ouvrable',
            ishipEconomiqueDeliveryRange: '1 - {{days}} jours ouvrables',
            ishipExpressPickupRange: 'Ramassage en 24h ou moins',
            ishipPickupRange: 'Ramassage en 48h ou moins',
            nextDayDeliveryRange: 'Livraison en 24-48h',
            preferredTitle: 'Express',
            cascadeSameDay: 'Jour même',
            cascadeNextDay: 'Lendemain',
            cascadeMultilegPosteCanada: 'Multileg - Poste Canada',
            cascadeMultilegCarrier: 'Multileg - {{carrier}}',
            cascadeMultilegEcono: 'Multileg - econo',
            cascadeMultilegExpress: 'Multileg - express',
            cascadeEconomy: 'Économique',
            cascadeEconomyCarrier: 'Économique - {{carrier}}',
            interurbanGroup: 'Interurbain',
            sameDayServicesGroup: 'Services jour-même',
            ishipViaPartner: 'Via notre réseau partenaire',
            livraisonRabaisViaPartner: 'Via notre réseau partenaire',
            partnerCarrier: 'Transporteur partenaire',
            thirdPartyOrderSummarySuffix: ' - Service opéré via notre réseau de partenaire',
        },
        scheduleRecurring: {
            dayPickup: 'Jour (ramassage au commerce)',
        },
        pickupTime: 'Heure de ramassage',
        pickupDate: 'Date de ramassage',
        secondLegPickupDate: 'Date de ramassage du second leg de livraison',
        deliveryDeadline: 'Délai de livraison',
        mins: 'mins',
        hours: 'h',
        delayForm: {
            title: 'Modifier le temps de préparation',
            now: 'Maintenant',
            toPlan: 'Planifier',
            pickupHere: 'À ramasser d\'ici:',
            date: 'Date',
            hour: 'Heure',
            hourFrom: 'De',
            hourTo: 'À',
            hourRange: 'Plage horaire de ramassage',
            hourRangeInvalid: 'L\'heure de fin doit être après l\'heure de début.',
            hourRangeRequired: 'Choisissez une date et une plage horaire (de – à).',
            noPickupSlots: 'Aucune heure de ramassage n\'est disponible pour cette date. Le commerce est fermé ou les heures sont passées.',
            selectDate: 'Sélectionner...',
            selectHour: 'Choisir...',
            pickupDeadline: 'Limite ramassage',
            defineTimeDeadline: 'Définir une heure limite de livraison',
            dateDeadline: 'Date (limite livraison)',
            timeDeadline: 'Heure (limite livraison)',
            modifyDelay: 'Modifier le délai',
            modifyServicePrice: 'Modifier le service/prix',
            deadlineShiftPreview: 'Livrer avant sera décalé au {when}.',
            deadlineShiftPreviewMany: 'Livrer avant sera décalé pour {count} livraisons.',
        },
        delayPart: {
            specifyTime: 'Spécifier l\'heure',
            spotServiceHours: 'Horaire service ponctuel : 09:00 à 17:00',
            directServiceHours: 'Horaire service direct : 10:00 à 20:00',
            contactForOtherHours: 'Contactez-nous pour des envoies en dehors de ces heures',
            schedulePickupLater: 'Planifier le ramassage une autre fois',
            schedulePickupLaterPortalHint: 'Vous pourrez planifier votre ramassage ultérieurement via le portail client. Un mot de passe temporaire vous sera envoyé par courriel après la confirmation de votre envoi.',
            thirdPartyPickupHintDateOnly: 'Ramassage : date seulement (fenêtre horaire à confirmer sur le portail transporteur si applicable).',
            thirdPartyPickupWindowDisclaimer:
            'Les dates et heures de ramassage pour ce service ne sont pas garanties. Le transporteur fera de son mieux pour les respecter. La date et l\'heure confirmées seront mises à jour dans le lien de suivi que vous recevrez.',
            posteCanadaDropoffNotice: 'Le ramassage n\'est pas inclus. Déposez votre colis dans un bureau de Poste Canada.',
            posteCanadaFindOffice: 'Trouver un bureau de poste à proximité',
            obiboxNextDayMinPickupWindow: 'Pour ce service, une fenêtre de ramassage d\'au moins 6 heures est requise.',
        },
        links: 'Liens',
        transportRequestForm: 'Formulaire de demande de transport',
        apiKey: 'Clé API',
        business: 'Modifier les infos du commerce',
        today: 'Aujourd\'hui',
        tomorrow: 'Demain',
        deliveryServices: {
            title: 'Service de livraison',
            getPricing: 'Obtenir le tarif',
            getPricingFirst: 'Entrez l\'adresse de destination et la grandeur du colis ci-dessus, puis cliquez pour voir les services disponibles et les tarifs.',
            fromTomorrow: 'Dès Demain',
            planned: 'Planifié',
            direct: 'Direct',
            punctual: 'Ponctuel',
            flexible: 'Flexible',
            business: 'Entreprise',
            thirdParty: 'Standard',
            nextDay: 'Le lendemain',
            nextDayToday: 'Ramassé aujourd\'hui',
            nextDayTomorrow: 'Ramassé demain',
            nextDayPlanned: 'Ramassé dès demain',
            deliveryIn: 'Livré dans',
            oneDay: '1 jour',
            daysUnit: 'jours',
            nextDayDescription: 'Livré le jour ouvrable suivant le ramassage',
            twoDays: '2 Jours',
            twoDaysToday: 'Ramassé aujourd\'hui',
            twoDaysTomorrow: 'Ramassé demain',
            twoDaysPlanned: 'Ramassé dès demain',
            twoDaysDescription: 'Livré en 2 jours ouvrables (non prioritaire)',
            skipGround: 'Skip Ground (Iship)',
            skipGroundTitle: 'Skip Ground',
            skipGroundDescription: 'Livraison en X jours ouvrables (selon devis Iship)',
            skipGroundTransitDays: '{{count}} jour(s) de transit',
            hubSkipGroundTimeToday: 'Ramassé aujourd\'hui, livraison selon devis Iship',
            hubSkipGroundTimePlanned: 'Ramassé demain, livraison selon devis Iship',
            hubPickupTime: 'Ramassé entre 9h et 17h',
            hubNextDayTimeToday: 'Ramassé aujourd\'hui, livré demain',
            hubNextDayTimePlanned: 'Ramassé demain avant 17h, livré le lendemain',
            hubTwoDaysTimeToday: 'Ramassé aujourd\'hui, livré dans 2 jours',
            hubTwoDaysTimePlanned: 'Ramassé demain avant 17h, livré dans 2 jours',
            fastPickupNextDayTitle: 'Ramassé en 4h, livré demain',
            fastPickupNextDayTimeToday: 'Ramassé aujourd\'hui, livré demain',
            fastPickupNextDayTimePlanned: 'Ramassé demain dans une plage de 4h, livré le lendemain',
            urgentTime: 'Ramassage dans une fenêtre de 60 minutes, puis livraison directe',
            fastTime: 'Ramassé et livré en 4h selon votre horaire.',
            sameDayTime: 'Ramassé avant 17h. Livré avant 21h.',
            businessTime: 'Ramassé et livré avant 17h',
            thirdPartyTime: 'Ramassé entre 9h et 17h',
            thirdPartyToday: 'Ramassé aujourd\'hui',
            thirdPartyTomorrow: 'Ramassé demain',
            thirdPartyPlanned: 'Ramassé dès demain',
            thirdPartyDescription: 'Livré 1-2 jours ouvrables après ramassage',
            doorToDoorPickupScheduled: 'Ramassage prévu le',
            scheduleTime1h: 'Planifié l\'heure, livré en 1h',
            scheduleTime4h: 'Plage de ramassage de 4h, à partir de: ',
            readyNow: 'Prêt maintenant',
            morningSlot: 'AM (Ramassé à partir de 9h et livré avant 13h)',
            afternoonSlot: 'PM (Ramassé à partir de 13h et livré avant 17h)',
            eveningSlot: 'Soir (Ramassé à partir de 17h et livré avant 21h)'
        },
        daysOfWeek: [
            'Lundi',
            'Mardi',
            'Mercredi',
            'Jeudi',
            'Vendredi',
            'Samedi',
            'Dimanche'
        ],
        months: [
            'janvier',
            'février',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'août',
            'septembre',
            'octobre',
            'novembre',
            'décembre'
        ],
        orderStatus: {
            toConfirm: 'A CONFIRMER',
            onWait: 'EN ATTENTE',
            assigned: 'ASSIGNÉ',
            headingToPickup: 'EN DIRECTION',
            arrived: 'ARRIVÉ',
            pickedUp: 'RÉCUPÉRÉE',
            onTheWay: 'EN ROUTE',
            cancelled: 'ANNULÉ',
            failed: 'ÉCHEC',
            refused: 'REFUSÉE',
            delivered: 'LIVRÉ',
            attention: 'ATTENTION',
            transit: 'TRANSIT',
            returning: 'EN RETOUR',
            returned: 'RETOUR',
            reactivate: 'Remettre en attente',
            reactivateHelp: 'Cette action réactive la commande annulée et la remet en attente de livraison.'
        },
        orderView: {
            title: 'Modifier la Commande',
            statut: 'Statut',
            driver: 'Livreur',
            distanceToOrigin: 'Distance commerce',
            distanceToClient: 'Distance client',
            unassign: 'Désassigner',
            assignDriver: 'Assigner un chauffeur',
            modify: 'Modifier',
            modifyFees: 'Modifer les tarifs $',
            modifyStatus: 'Modifer le status',
            updateDelay: 'Modifier les délais',
            delayUpdateCurrentService: 'Service actuel :',
            completeOrder: 'Complété',
            cancelOrder: 'Annuler',
            pickup: 'Ramassage',
            delivery: 'Livraison',
            confirmOrder: 'Confirmer la commande',
            confirmPickup: 'Confirmer le ramassage',
            confirmPickupSubmit: 'Confirmer',
            confirmPickupCancel: 'Annuler',
            confirmPickupQuoteFallback: 'Tarification en direct indisponible — les options de ramassage sont basées sur cette commande.',
            confirmPickupQuoteUnavailable: 'La tarification en direct est indisponible et cette commande n\'a pas de frais enregistrés. Veuillez réessayer plus tard.',
            details: 'Détails',
            statusSection: 'Status',
            delays: 'Délais',
            fees: 'Frais',
            actions: 'Actions',
            assigned: 'Assigné',
            arrived: 'Arrivé',
            pickedUp: 'Récupéré',
            onTheWay: 'En route',
            completed: 'Complété',
            canceledAt: 'Annulé',
            thirdParty: 'Livraison tierce',
            amount: 'Montant',
            route: 'Route',
            orderHeading: 'Commande #{{id}}',
            format: 'Format',
            box: 'boîte',
            boxes: 'boîtes',
            podRequired: 'Preuve de livraison requise',
            signatureRequired: 'Signature requise',
            paymentRequired: 'Paiement requis',
            podReceived: 'Preuve de livraison reçue',
            registeredMailReturnNote: 'Courrier recommandé : en cas d\'échec de remise, planifier un retour gratuit à l\'expéditeur.',
        },
        cancelView: {
            title: 'Êtes-vous sûr de vouloir annuler?',
            cancelOrder: 'Annuler la commande',
            specifyReason: '(Facultatif) Spécifiez la raison',
            noDriverAvailable: 'Aucun livreur disponible',
            deliveryProblem: 'Problème pendant la livraison',
            orderNotReady: 'Commande pas prête',
            clientAddressNotFound: 'Adresse du client introuvable',
            inactifClient: 'Client inactif',
            orderContentTooBig: 'Contenu de la commande trop gros'
        },
        trackingLink: 'Lien de suivi',
        printDeliveryLabel: 'Imprimer l\'étiquette d\'expédition',
        sendToEmail: 'Envoyer par courriel',
        send: 'Envoyer',
        trackingLinkSent: 'Lien de suivi envoyé à',
        errors: {
            fetchTrackingLink: 'Échec de la récupération du lien de suivi',
            sendTrackingLink: 'Échec de l\'envoi du lien de suivi. Veuillez réessayer.',
        },
        enterValidEmail: 'Veuillez entrer une adresse courriel valide',
        pickup: 'Ramassage',
        destination: 'Destination',
        servicesNotAvailable: 'Nos services ne sont pas actuellement disponible à votre adresse.',
        assignToMyDrivers: 'Assigner à mes chauffeurs',
        subcontractToOnShip: 'Sous-traiter à OnShip Ça!',
        deliveryDelays: 'Délais de livraison',
        calculatedDistance: 'Distance calculée',
        deliveryDeadlines: 'Délais de livraison',
        assignDriver: 'Assigner un livreur',
        waitingDrivers: 'Livreurs en attente',
        vehicleVolume: {
            label: 'Volume du véhicule',
            beforeAfter: '{before}% → {after}%',
            currentCapacity: 'Capacité actuel',
            afterCapacity: 'Après',
            capacityUnknown: 'capacité inconnue',
            riskFull: 'Risque de véhicule plein',
        },
        shiftWarning: 'Le quart de travail ne couvre pas la plage horaire de la route.',
        shiftWindow: 'Quart {start}–{end}',
        compatibleShift: 'Quart compatible',
        compatibleShiftWindow: 'Quart compatible {start}–{end}',
        notAvailableThisDate: 'Pas disponible cette date',
        shiftMismatch: 'Quart incompatible',
        shiftBeforeShift: 'Avant le quart',
        merchantDriverBlacklist: 'Liste noire du commerce',
        tags: {
            assignedDriver: '(Livreur assigné)',
            libre: 'Libre',
            enRoute: 'En route',
            upcomingShift: 'Quart bientôt',
        }
    },
    dataTable: {
        actions: 'Actions',
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        vehicleType: 'Type de véhicule',
        address: 'Adresse',
        city: 'Ville',
        category: 'Catégorie',
        filterInclude: 'Inclure',
        filterExclude: 'Exclure',
        filterClear: 'Retirer la sélection',
        categoryInclude: 'Inclure ces catégories',
        categoryExclude: 'Exclure ces catégories',
        categoryClear: 'Retirer la sélection',
        lastActivity: 'Dernière activité',
        lifetimeValue: 'Valeur totale $',
        postalCode: 'Code postal',
        status: 'Statut',
        date: 'Date',
        inscription: 'Inscription',
        onboarding: 'Onboarding',
        onboardingStepsTitle: 'Étapes d\'onboarding',
        onboardingStepCompleted: 'Complétée',
        onboardingStepPending: 'À faire',
        onboardingTooltipAria: 'Onboarding: {{completed}} sur {{total}} étapes complétées',
        onboardingSteps: {
            formation: 'Formation',
            theoric_exam: 'Examen théorique',
            account_info: 'Infos personnelles',
            tools: 'Outils de travail',
            appointment: 'Activation du compte',
            material: 'Matériel',
        },
        time: 'Heure',
        delay: 'Délai',
        content: 'Contenu',
        amount: 'Montant',
        driver: 'Chauffeur',
        merchant: 'Commerçant',
        destination: 'Destination',
        pickup: 'Ramassage',
        delivery: 'Livraison',
        deadline: 'Échéance',
        commission: 'Commission',
        fees: 'Frais',
        price: 'Prix',
        distance: 'Distance',
        duration: 'Durée',
        route: 'Route',
        routes: 'Routes',
        completedStops: 'Arrêts complétés',
        confirmed: 'Confirmé',
        comments: 'Commentaires',
        scheduled: 'Planifié',
        routeCompleted: 'Route terminée',
        estimatedTime: 'Temps estimé',
        actualTime: 'Temps réel',
        merchantPayment: 'Paiement commerce',
        driverPayment: 'Paiement livreur',
        testPayment: 'Test paiement',
        timeDifference: 'Actuel vs Estimé',
        optimizationPercentage: 'Pourcentage d\'optimisation',
        experimentalData: 'Données expérimentales',
        costPerKm: 'Coût / KM',
        avgDistanceBetweenStops: 'Distance moyenne entre les arrêts',
        totalDeliveryKm: 'KM total livraisons',
        totalRouteKm: 'KM total route',
        date2: 'Date 2',
        orders: 'Commandes',
        deliveries: 'Livraisons',
        invoices: 'Factures',
        payments: 'Paiements',
        payment: 'Paiement',
        method: 'Méthode',
        receipts: 'Reçus',
        reports: 'Rapports',
        users: 'Utilisateurs',
        user: 'Utilisateur',
        roles: 'Rôles',
        permissions: 'Permissions',
        active: 'Actif',
        inactive: 'Inactif',
        online: 'En ligne',
        offline: 'Hors ligne',
        assigned: 'Assigné',
        unassigned: 'Non assigné',
        completed: 'Terminé',
        pending: 'En attente',
        cancelled: 'Annulé',
        edit: 'Modifier',
        delete: 'Supprimer',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce',
        modify: 'Modifier',
        rates: 'Tarifs',
        view: 'Voir',
        add: 'Ajouter',
        save: 'Enregistrer',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        search: 'Rechercher',
        filter: 'Filtrer',
        export: 'Exporter',
        import: 'Importer',
        download: 'Télécharger',
        upload: 'Téléverser',
        exportPODs: 'Exporter les PODs',
        item: 'élément',
        items: 'éléments',
        selected: 'sélectionné(s)',
        generate: 'Générer',
        print: 'Imprimer',
        send: 'Envoyer',
        receive: 'Recevoir',
        start: 'Démarrer',
        end: 'Terminer',
        pause: 'Pause',
        resume: 'Reprendre',
        stop: 'Arrêter',
        close: 'Fermer',
        open: 'Ouvrir',
        show: 'Afficher',
        hide: 'Masquer',
        expand: 'Développer',
        collapse: 'Réduire',
        refresh: 'Actualiser',
        reload: 'Recharger',
        update: 'Mettre à jour',
        create: 'Créer',
        remove: 'Supprimer',
        duplicate: 'Dupliquer',
        copy: 'Copier',
        paste: 'Coller',
        cut: 'Couper',
        undo: 'Annuler',
        redo: 'Rétablir',
        select: 'Sélectionner',
        deselect: 'Désélectionner',
        selectAll: 'Tout sélectionner',
        deselectAll: 'Tout désélectionner',
        noData: 'Aucune donnée disponible',
        error: 'Erreur',
        success: 'Succès',
        warning: 'Avertissement',
        info: 'Information',
        notifications: 'Notifications',
        rowDropdown: {
            ariaLabel: 'Plus d\'actions pour cette ligne',
            assignSuggestion: 'Appliquer la suggestion',
            assignDelivery: 'Assigner la livraison',
            addDeliveryToRoute: 'Ajouter à une route',
            editDelay: 'Modifier le délai',
            viewOrderDetails: 'Voir la commande',
            sendTrackingShare: 'Lien de suivi',
            remunerationRates: 'Tarifs de rémunération',
            bankingSetup: 'Virements bancaires',
            merchantCommissionEdit: 'Modifier les commissions',
            changePasswordDriver: 'Mot de passe',
            merchantUsersManage: 'Utilisateurs du commerce',
            recurringPricing: 'Modifier les tarifs',
            viewInvoicePdf: 'Voir la facture',
            emailInvoicePdf: 'Envoyer par courriel',
            depositReconciliationInvoice: 'Rapprochement carte de crédit',
            listCreditCardRefunds: 'Voir remboursements carte',
            exportOrdersCsvDetail: 'Télécharger CSV des commandes',
            payInvoiceCard: 'Payer cette facture',
            proofOfDelivery: 'Preuve de livraison',
            proofOfDeliveryUnavailable: 'Preuve de livraison (non disponible)',
            proofOfDeliveryUnavailableHint: 'Aucune preuve n\'a été capturée pour cette livraison.',
            carrierTrackingUnavailableHint: 'Le suivi du transporteur n\'est pas encore disponible.',
            adjustCommissionDelivery: 'Ajuster commissions livreur/commerce',
            assignStopsRoute: 'Assigner la route',
            routeHideShowOnMap: 'Visibilité sur la carte',
            exportThisRoute: 'Exporter CSV',
            openRouteDashboard: 'Ouvrir la route',
            shipmentPrintLabel: 'Imprimer l\'étiquette',
            shipmentCarrierTracking: 'Suivi transporteur',
            shipmentEditResubmit: 'Modifier l\'expédition',
            shipmentCancelConfirm: 'Annuler l\'expédition',
            shipmentSchedulePickupLar: 'Demander un ramassage',
            shipmentCancelPickupLar: 'Annuler le ramassage',
            shipmentDuplicate: 'Dupliquer l’expédition',
            shipmentChangeCarrier: 'Changer de transporteur',
            reactivate: 'Réactiver',
            viewDriverReceipt: 'Voir le reçu',
            paymentMethodMerchant: 'Méthode de paiement',
            businessHoursMerchant: 'Heures d\'ouverture',
            packageDefaultsMerchant: 'Dimensions de colis par défaut',
        },
        yes: 'Oui',
        no: 'Non',
        true: 'Vrai',
        false: 'Faux',
        enabled: 'Activé',
        disabled: 'Désactivé',
        visible: 'Visible',
        hidden: 'Masqué',
        public: 'Public',
        private: 'Privé',
        draft: 'Brouillon',
        published: 'Publié',
        archived: 'Archivé',
        deleted: 'Supprimé',
        restored: 'Restauré',
        approved: 'Approuvé',
        rejected: 'Rejeté',
        pending: 'En attente',
        processing: 'En traitement',
        queued: 'En file d\'attente',
        running: 'En cours',
        stopped: 'Arrêté',
        failed: 'Échoué',
        completed: 'Terminé',
        cancelled: 'Annulé',
        expired: 'Expiré',
        valid: 'Valide',
        invalid: 'Invalide',
        required: 'Requis',
        optional: 'Optionnel',
        primary: 'Primaire',
        secondary: 'Secondaire',
        tertiary: 'Tertiaire',
        urgent: 'Urgent',
        normal: 'Normal',
        low: 'Faible',
        high: 'Élevé',
        critical: 'Critique',
        important: 'Important',
        minor: 'Mineur',
        major: 'Majeur',
        total: 'Total',
        subtotal: 'Sous-total',
        tax: 'Taxe',
        discount: 'Remise',
        shipping: 'Expédition',
        handling: 'Manutention',
        insurance: 'Assurance',
        warranty: 'Garantie',
        refund: 'Remboursement',
        credit: 'Crédit',
        debit: 'Débit',
        balance: 'Solde',
        due: 'Dû',
        overdue: 'En retard',
        paid: 'Payé',
        unpaid: 'Non payé',
        partial: 'Partiel',
        full: 'Complet',
        empty: 'Vide',
        available: 'Disponible',
        unavailable: 'Indisponible',
        inStock: 'En stock',
        outOfStock: 'Rupture de stock',
        limited: 'Limité',
        unlimited: 'Illimité',
        restricted: 'Restreint',
        allowed: 'Autorisé',
        denied: 'Refusé',
        granted: 'Accordé',
        revoked: 'Révoqué',
        suspended: 'Suspendu',
        terminated: 'Terminé',
        client: 'Client',
        cost: 'Coût',
        send: 'Envoyer',
        generate: 'Générer',
        invoice: 'Facture',
        creationDate: 'Date de création',
        displayCompletedOrders: 'Afficher les commandes complétées',
        orderView: {
            title: 'Modifier la Commande',
            statut: 'Statut',
            driver: 'Livreur',
            distanceToOrigin: 'Distance commerce',
            distanceToClient: 'Distance client',
            unassign: 'Désassigner',
            assignDriver: 'Assigner un chauffeur',
            modify: 'Modifier',
            modifyFees: 'Modifer les tarifs $',
            modifyStatus: 'Modifer le status',
            updateDelay: 'Modifier les délais',
            delayUpdateCurrentService: 'Service actuel :',
            completeOrder: 'Complété',
            cancelOrder: 'Annuler',
            pickup: 'Ramassage',
            delivery: 'Livraison',
            confirmOrder: 'Confirmer la commande',
            confirmPickup: 'Confirmer le ramassage',
            confirmPickupSubmit: 'Confirmer',
            confirmPickupCancel: 'Annuler',
            confirmPickupQuoteFallback: 'Tarification en direct indisponible — les options de ramassage sont basées sur cette commande.',
            confirmPickupQuoteUnavailable: 'La tarification en direct est indisponible et cette commande n\'a pas de frais enregistrés. Veuillez réessayer plus tard.',
            details: 'Détails',
            statusSection: 'Status',
            delays: 'Délais',
            fees: 'Frais',
            actions: 'Actions',
            assigned: 'Assigné',
            arrived: 'Arrivé',
            pickedUp: 'Récupéré',
            onTheWay: 'En route',
            completed: 'Complété',
            canceledAt: 'Annulé',
            thirdParty: 'Livraison tierce',
            amount: 'Montant',
            route: 'Route',
            orderHeading: 'Commande #{{id}}',
            format: 'Format',
            box: 'boîte',
            boxes: 'boîtes',
            podRequired: 'Preuve de livraison requise',
            signatureRequired: 'Signature requise',
            paymentRequired: 'Paiement requis',
            podReceived: 'Preuve de livraison reçue',
            registeredMailReturnNote: 'Courrier recommandé : en cas d\'échec de remise, planifier un retour gratuit à l\'expéditeur.',
        },
        cancelView: {
            title: 'Êtes-vous sûr de vouloir annuler?',
            cancelOrder: 'Annuler la commande',
            specifyReason: '(Facultatif) Spécifiez la raison',
            noDriverAvailable: 'Aucun livreur disponible',
            deliveryProblem: 'Problème pendant la livraison',
            orderNotReady: 'Commande pas prête',
            clientAddressNotFound: 'Adresse du client introuvable',
            inactifClient: 'Client inactif',
            orderContentTooBig: 'Contenu de la commande trop gros'
        },
        trackingLink: 'Lien de suivi',
        printDeliveryLabel: 'Imprimer l\'étiquette d\'expédition',
        sendToEmail: 'Envoyer par courriel',
        trackingLinkSent: 'Lien de suivi envoyé à',
        errors: {
            fetchTrackingLink: 'Échec de la récupération du lien de suivi',
            sendTrackingLink: 'Échec de l\'envoi du lien de suivi. Veuillez réessayer.'
        },
        enterValidEmail: 'Veuillez entrer une adresse courriel valide',
        pickup: 'Ramassage',
        destination: 'Destination',
        servicesNotAvailable: 'Nos services ne sont pas actuellement disponible à votre adresse.',
        assignToMyDrivers: 'Assigner à mes chauffeurs',
        subcontractToOnShip: 'Sous-traiter à OnShip Ça!',
        deliveryDelays: 'Délais de livraison',
        calculatedDistance: 'Distance calculée',
    },
    dashboard: {
        action1: 'Faire un envoi',
        action2: 'Livreurs dédiés',
        actions: {
            addOrder: 'Faire un envoi',
            addToRoad: 'Ajouter à une route',
            assignRoad: 'Assigner la route',
            cancel: 'Annuler',
            closeRoad: 'Fermer la route',
            colorOrdersByRoad: 'Identifier les routes',
            createRoad: 'Créer une route',
            displayCompletedOrders: 'Afficher les commandes complétés',
            displayTodaySchedule: 'Afficher l\'horaire d\'aujourd\'hui',
            exportRoads: 'Exporter les routes',
            generateRoad: 'Générer la route',
            import: 'Import',
            info: 'Info',
            map: 'Carte',
            offline: 'Hors-ligne',
            pay: 'Payer les factures',
            save: 'Sauvegarder',
            updateRoad: 'Modifier la route'
        },
        actionsassign: 'Assigner',
        activeRoutes: '{count} routes actives',
        comments: 'Avis',
        completedDedicatedServices: 'Quarts de travail complétés',
        completedOrders: 'Commandes livrées',
        credits: 'Crédits rabais',
        cycle: 'Récurrence',
        dataHistory: 'Historique - 30 derniers jours',
        discoverDriverPlacementService: {
            link: 'Découvrez notre service de placement de chauffeur',
            tail: 'et suivez vos chauffeurs sur la carte grâce à la <b>technologie GPS</b>.'
        },
        driver: {
            prioritize: 'Prioriser',
            setAvailable: 'Rendre disponible',
            setDoNotDisturb: 'Ne pas déranger',
            status: {
                doNotDisturb: 'Ne pas déranger',
                inDelivery: 'En livraison'
            },
            unprioritize: 'Dé-prioriser'
        },
        drivers: 'Livreurs',
        error: 'Une erreur est survenue, veuillez réessayer plus tard',
        importSuccess: 'commandes importées avec succès',
        importFailed: 'L\'importation a échoué',
        importError: 'Une erreur s\'est produite lors de l\'importation',
        csvImport: {
            title: 'Importer des commandes (CSV)',
            upload: 'Téléverser',
            map: 'Colonnes',
            back: 'Retour',
            preview: 'Aperçu',
            progress: 'Création',
            pickup: 'Ramassage',
            downloadTemplate: 'Télécharger le modèle CSV',
            chooseFile: 'Choisir un fichier CSV…',
            nextPreview: 'Analyser le fichier',
            confirmMapping: 'Continuer vers l’aperçu',
            mapHint: 'Vérifiez le mapping des en-têtes CSV. Les lignes surlignées nécessitent une confirmation.',
            sourceHeader: 'En-tête CSV',
            targetField: 'Champ d’import',
            confidence: 'Confiance',
            fieldNone: 'Ignorer la colonne',
            mapFailed: 'Impossible de proposer le mapping des colonnes',
            mapHeadersMissing: 'Impossible de lire les en-têtes CSV',
            mapNeedsAddress: 'Associez au moins une colonne à destination_address',
            startImport: 'Créer les commandes',
            confirmPickup: 'Confirmer le ramassage',
            skipRow: 'Ignorer',
            localService: 'Service local par défaut (modifiable par ligne)',
            thirdPartyDefault: 'Service partenaire par défaut (hors zone)',
            cheapest: 'Le plus économique',
            fastest: 'Le plus rapide',
            routingLocal: 'Local',
            routingThirdParty: 'Partenaire',
            routingInvalid: 'À corriger',
            row: 'Ligne',
            address: 'Adresse',
            zone: 'Zone',
            service: 'Service',
            price: 'Prix',
            totalPrice: 'Total',
            summaryTitle: 'Commandes créées',
            blockingAnomalies: 'Les lignes en erreur sont ignorées. Vous pouvez continuer avec les lignes valides.',
            anomaly: {
                missing_address: 'Adresse manquante',
                missing_postal: 'Code postal manquant',
                malformed_address: 'Adresse invalide',
                missing_dimensions: 'Dimensions du colis requises (hors zone)',
                third_party_disabled: 'Livraison partenaire non activée pour ce commerce',
                unparseable_packages: 'Colonne packages illisible',
                outside_canada: 'Adresse hors Canada',
            },
            warning: {
                city_inferred: 'Ville déduite de l’adresse',
                postal_inferred: 'Code postal déduit de l’adresse',
                quantity_defaulted: 'Quantité par défaut: 1',
                coords_incomplete: 'Latitude et longitude doivent être fournies ensemble',
                coords_invalid: 'Latitude/longitude invalides; l’adresse sera géocodée',
            },
            judgment: {
                typesafe_low_confidence: 'Ignorée par la revue IA — adresse ou complétude insuffisante',
            },
            columnsTitle: 'Colonnes acceptées',
            exampleHint: 'Si latitude et longitude sont fournies, l’adresse n’est pas géocodée via Google.',
            colLatitude: 'Latitude de destination (optionnel). Si latitude et longitude sont fournies, l’adresse n’est pas géocodée via Google.',
            colLongitude: 'Longitude de destination (optionnel, négative au Québec, ex. -73.56). Requiert latitude.',
            queued: 'En file',
            processing: 'Traitement',
            completed: 'Terminé',
            failed: 'Échec',
            close: 'Fermer',
            sameDay: 'Flexible (avant 21h)',
            sameDayPlanned: 'Flexible planifié',
            fast: 'Ponctuel (4h)',
            fastPlanned: 'Ponctuel planifié',
            urgent: 'Direct',
            urgentPlanned: 'Direct planifié',
            business: 'Entreprise (avant 17h)',
            businessPlanned: 'Entreprise planifié',
            splitPickupHint: 'Les fenêtres de ramassage local et partenaire ne se chevauchent pas. Confirmez chaque groupe séparément.',
            localPickupGroup: 'Ramassage local',
            partnerPickupGroup: 'Ramassage partenaire',
            confirmLocalPickup: 'Confirmer le ramassage local',
            confirmPartnerPickup: 'Confirmer le ramassage partenaire',
            localPickupConfirmed: 'Ramassage local confirmé.',
            partnerPickupConfirmed: 'Ramassage partenaire confirmé.',
        },
        headers: {
            client: 'Client',
            comments: 'Commentaire',
            completedStops: 'Arrets complétés',
            date: 'Date',
            delay: 'Délai',
            delivery: 'Livraison',
            driver: 'Livreur',
            pickup: 'Ramassage',
            hour: 'Heure',
            itinerary: 'Itinéraire',
            noDedicatedDriverToMerchant: 'Aucun chauffeur attitré à votre commerce',
            noDriver: 'Aucun livreur',
            noDriverAssigned: 'Aucun livreur assigné',
            noDriverToSchedule: 'Aucun livreur à l\'horaire',
            noOnlineDriver: 'Aucun livreur en ligne',
            offlineDrivers: 'Livreurs hors-ligne',
            onlineDriver: 'Livreurs en ligne',
            onlineDrivers: 'Livreurs en ligne',
            ordersOrder: 'Ordre des commandes',
            routeNumber: 'Route #',
            scheduleOfTheDay: 'Horaire de la journée',
            status: 'Statut',
            todaySchedule: 'Aucun livreur à l\'horaire'
        },
        lastInvoice: 'Dernière facture',
        loading: 'Chargement...',
        map: 'Carte',
        myOnlineDrivers: 'Mes livreurs en ligne',
        manageDriversList: 'Gérer la liste de livreurs',
        nbHoursWorked: 'Nb heures travaillées',
        noComments: 'Pas de commentaires disponibles',
        noItinery: 'Aucun itinéraire en cours',
        noOrders: 'Aucune commandes en cours',
        order: 'commande',
        orders: 'Commandes',
        ordersOrder: 'Ordre des commandes',
        pageTitle: 'Tableau de bord - Commerçant - Commandes',
        paymentMethod: 'Méthode de paiement',
        roadComment: 'Commentaire pour la route',
        roadScheduled: 'Heure prévue',
        routes: 'Routes',
        stats: 'Statistiques',
        stopsCompleted: '{current} / {total} complétés',
        title: 'Que souhaitez vous faire aujourd\'hui?',
        totalDeliveryHours: 'Heures travaillées',
        hoursOnRoute: 'Heures en route',
        driverEarnings: {
            earnings: 'Revenus',
            paidTime: 'Temps payé',
            distanceTraveled: 'Distance parcourue',
            commissions: 'Commissions',
            dedicatedShifts: 'Services attitrés',
            tips: 'Pourboires prépayés',
            guarantee: 'Garantie',
            bonus: 'Bonus',
            totalEarnings: 'Revenus totaux',
            weeklyView: 'Statistiques par semaine',
            weeklyTitle: 'Revenus hebdomadaires',
            weekTotal: 'Total de la semaine',
            activity: 'Activité',
            online: 'En ligne',
            busy: 'En course',
            guaranteedHours: 'Heures garanties',
            previousWeek: 'Semaine précédente',
            nextWeek: 'Semaine suivante',
            backToDriver: 'Retour au chauffeur',
            noWeeklyData: 'Aucun revenu pour cette semaine',
            today: 'Aujourd\'hui',
            pickDate: 'Choisir une date',
            previous: 'Précédent',
            next: 'Suivant',
            noEarnings: 'Aucun revenu pour cette journée',
            routeNumber: 'Route #',
            nbStops: 'Nb Arrêts',
            completedAt: 'Terminé à',
            noOrders: 'Aucune commande trouvée',
        },
    },
    planner: {
        title: 'Planificateur',
        subtitle: 'Préparez les livraisons et les livreurs, puis générez les routes proposées.',
        date: 'Date de planification',
        dateEnd: 'Fin de plage',
        multiDayHint: 'Plan multi-jours ({days} jours) — les livraisons flexibles iront sur le meilleur jour',
        deliveries: 'Livraisons',
        scheduledDrivers: 'Livreurs à l’horaire',
        deliveryCount: '{count} livraison(s) incluse(s)',
        excludedCount: '{count} exclue(s)',
        noDeliveries: 'Aucune livraison pour cette date.',
        unknownMerchant: 'Commerce inconnu',
        exclusions: 'Livraisons à inclure',
        deliverySelection: 'Sélection des livraisons',
        includeAll: 'Tout inclure',
        excludeAll: 'Tout exclure',
        driverSchedule: 'Horaire des livreurs',
        results: 'Routes proposées',
        copilotSuggestions: 'Suggestions Copilot',
        copilotEmpty: 'Aucune suggestion Copilot pour cette date.',
        copilotLoading: 'Chargement des suggestions…',
        noDriverYet: 'Sans livreur',
        linkDriver: 'Lier un livreur',
        createdRoad: 'Route créée',
        reserve: 'Réserve',
        fullCapacity: 'Pleine capacité',
        noScheduledDrivers: 'Aucun livreur à l’horaire.',
        scheduledWithoutRoute: 'À l’horaire, sans route proposée',
        routingRules: '{count} règle(s) du guide de répartition applicable(s)',
        planAction: 'Créer le plan de répartition',
        loading: 'Chargement du contexte…',
        optimizing: 'Optimisation en cours…',
        queued: 'Planification en file d’attente…',
        unassigned: 'Non assignées ({count})',
        summary: '{shipments} livraison(s) planifiée(s) — {routes} route(s) proposée(s)',
        planningDate: 'Plan du {date}',
        planningDateRange: 'Plan du {start} au {end}',
        skippedLocked: '{count} déjà sur une route (ignorées)',
        addToRoadCapacity: 'Capacité restante : {remaining}',
        existingStopsKept: '{count} arrêt(s) déjà sur la route (conservés)',
        alreadyOnRoad: 'Déjà sur une route',
        changeDriver: 'Changer de livreur',
        driverAvailable: 'Disponible',
        swapWithRoute: 'Échanger',
        routeKept: 'Itinéraire conservé — même ordre d’arrêts.',
        cannotChangeAddToRoad: 'Cette suggestion s’ajoute à une route existante : le livreur ne peut pas être changé.',
        assignThisRoute: 'Assigner cette route',
        alreadyHasRoute: 'Déjà une route',
        selectAllSuggestions: 'Tout sélectionner',
        selectSuggestion: 'Sélectionner {title}',
        removeSelection: 'Supprimer la sélection ({count})',
        removeConfirmTitle: 'Supprimer la sélection',
        removeConfirm: 'Supprimer {count} suggestion(s) de route ? Cette action est définitive.',
        removeSuccess: '{count} suggestion(s) de route supprimée(s).',
        removeSuccessWithSkipped: '{count} suggestion(s) de route supprimée(s). {skipped} déjà traitée(s).',
        removeNone: 'Aucune suggestion supprimée. {skipped} déjà traitée(s).',
        removePartial: '{count} suggestion(s) supprimée(s).',
        removeForbidden: 'Vous n’avez pas la permission de supprimer ces suggestions.',
        removeInvalid: 'Impossible de supprimer la sélection.',
        removeError: 'Impossible de supprimer les suggestions. Veuillez réessayer.',
        modes: {
            live: 'En direct (livreurs en ligne)',
            scheduled: 'Planifié (quarts)',
        },
        periods: {
            morning: 'Matin',
            afternoon: 'Après-midi',
            evening: 'Soir',
            unspecified: 'Non classé',
        },
        clusterHeat: 'Volume par cluster',
        qa: {
            title: 'Contrôle qualité',
            score: 'Score {score}',
            zigzag: 'Zigzag détecté',
            continuous: 'Direction continue',
            slaOk: 'SLA OK',
            slaRisk: 'SLA à risque',
        },
        errors: {
            load: 'Impossible de charger les livraisons et les quarts.',
            noDeliveries: 'Aucune livraison sélectionnée.',
            rangeTooLong: 'La plage ne peut pas dépasser {max} jours.',
        },
    },
    sameDayPlan: {
        title: 'Suggestion de livreurs',
        menuAction: 'Suggestion de livreurs',
        subtitle: 'Proposition par livreur, comme un plan de routes — vous pouvez changer le livreur d’une livraison avant d’accepter.',
        dragHint: 'Glissez un arrêt entre livreurs pour déplacer la livraison (ramassage + livraison). Réordonnez les arrêts dans une liste comme avant.',
        dropHere: 'Déposer une livraison ici',
        summary: '{deliveries} livraison(s) — {routes} route(s) proposée(s)',
        optimize: 'Optimiser',
        optimizing: 'Optimisation en cours…',
        acceptAll: 'Accepter les routes ({count})',
        confirmAccept: 'Accepter {count} route(s) proposée(s) ?',
        unassigned: 'Non assignées ({count})',
        newRoute: 'Nouvelle',
        stops: '{count} arrêt(s)',
        stop: 'Arrêt',
        delivery: 'Livraison',
        pickupStop: 'Ramassage',
        deliveryStop: 'Livraison',
        changeDriver: 'Changer de livreur',
        distanceKm: '{km} km',
        durationMin: '{minutes} min',
        errors: {
            load: 'Impossible de calculer le plan de routes.',
            noDeliveries: 'Aucune livraison sélectionnée.',
            reassign: 'Impossible de recalculer après le changement de livreur.',
            accept: 'Impossible d’accepter une ou plusieurs routes.',
            emptyRoute: 'Une route proposée est vide.',
        },
    },
    navigation: {
        dashboard: 'Tableau de bord',
        search: 'Recherche',
        deliveries: 'Livraisons',
        recurringDeliveries: 'Livraisons récurrentes',
        drivers: 'Livreurs',
        online: 'En ligne',
        all: 'Tous',
        active: 'Actifs',
        inactive: 'Inactifs',
        incidents: 'Incidents',
        routes: 'Routes',
        current: 'En cours',
        history: 'Historique',
        routesHistory: 'Historique des routes',
        routingGuide: 'Guide de répartition',
        planner: 'Planificateur',
        schedule: 'Horaires',
        merchantSchedule: 'Horaires 5@8',
        roadSchedules: 'Squelette terrain',
        schedulePlanning: 'Planification des horaires',
        scheduleDedicatedLive: 'Service attitré — live',
        logs: 'Logs connexion',
        driverAvailabilities: 'Disponibilités livreurs',
        trackingHistory: 'Historique de suivi',
        reports: 'Rapports',
        ordersHistory: 'Historique',
        ordersReport: 'Rapport des livraisons',
        mapReport: 'Rapport de carte',
        addresses: 'Liste d\'adresses enregistrées',
        business: 'Modifier les infos du commerce',
        users: 'Utilisateurs',
        billing: 'Facturation',
        invoices: 'Factures',
        payments: 'Paiements',
        dispatcherReports: 'Rapports',
        orders: 'Commandes',
        transactions: 'Transactions',
        kpi: 'KPI',
        dailyProfitability: 'Rentabilité quotidienne',
        volumeEstimate: 'Estimation volume',
        merchants: 'Commerces',
        inactiveMerchants: 'Commerces inactifs',
        invoicing: 'Facturation',
        merchantInvoices: 'Factures commerces',
        driverReceipts: 'Reçus livreurs',
        settings: 'Paramètres',
        support: 'Support',
        downloadApp: 'Télécharger l\'app',
        manage: 'Gérer',
        showMap: 'Carte',
        dedicatedDrivers: 'Livreurs dédiés',
    },
    merchantDetail: {
        recentOrders: 'Dernières commandes',
        recentInvoices: 'Dernières factures',
        noOrders: 'Aucune commande',
        noInvoices: 'Aucune facture',
        copied: 'Copié',
        profileTab: 'Fiche',
        currentOrdersTab: 'Commandes en cours',
        viewCurrentOrders: 'Voir les commandes en cours',
        loadOrdersError: 'Impossible de charger les commandes en cours.',
    },
    search: {
        title: 'Recherche globale',
        placeholder: 'Rechercher une commande, route, livreur, commerce, facture, suivi...',
        merchantPlaceholder: 'Rechercher une commande, une adresse, une facture...',
        merchantPlaceholderWithFleet: 'Rechercher une commande, une adresse, une facture, un livreur, une route...',
        hint: 'Recherchez par ID, nom, adresse, téléphone, courriel ou numéro de suivi',
        shortcutHint: 'pour rechercher',
        minChars: 'Saisissez au moins 2 caractères',
        searching: 'Recherche en cours...',
        noResults: 'Aucun résultat pour « {{query}} »',
        viewAll: 'Voir tous les résultats',
        errorTimeout: 'La recherche a expiré. Veuillez réessayer.',
        error: 'Une erreur est survenue lors de la recherche.',
        groups: {
            orders: 'Commandes',
            destinations: 'Adresses',
            routes: 'Routes',
            drivers: 'Livreurs',
            merchants: 'Commerces',
            invoices: 'Factures',
            driver_reports: 'Rapports livreurs',
        },
        matchedOn: {
            name: 'Nom',
            recipient: 'Destinataire',
            address: 'Adresse',
            city: 'Ville',
            postal_code: 'Code postal',
            phone: 'Téléphone',
            email: 'Courriel',
            external_id: 'ID externe',
            tracking_number: 'Numéro de suivi',
            merchant: 'Commerce',
            driver: 'Livreur',
            order: 'Commande',
            id: 'ID',
        },
    },
    destinations: {
        noSavedAddress: 'Aucune adresses enregistrées',
        subcontractorScopeHint: 'Adresses partagées au niveau du sous-traitant (sans commerce associé).',
        headers: {
            name: 'Nom',
            phoneNumber: 'Numéro de téléphone',
            address: 'Adresse',
            city: 'Ville',
            actions: 'Actions'
        },
        actions: {
            addAddress: 'Ajouter une adresse',
            modifyAddress: 'Modifier l\'adresse',
            newAddress: 'Nouvelle adresse',
            import: 'Importer',
            export: 'Exporter',
            delete: 'Supprimer',
            bulkDelete: 'Supprimer la sélection'
        },
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette adresse?',
        bulkDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer les {{count}} adresses sélectionnées?',
        import: {
            title: 'Importer des adresses',
            description: 'Importez des adresses à partir d\'un fichier CSV. Les colonnes address, city et postal_code sont requises. latitude et longitude sont optionnels (géocodage automatique si absents).',
            acceptedColumns: 'Colonnes CSV acceptées',
            columnName: 'Colonne',
            descriptionColumn: 'Description',
            chooseFile: 'Choisir un fichier CSV...',
            importButton: 'Importer',
            name: 'Nom du destinataire',
            phone: 'Numéro de téléphone',
            address: 'Adresse (requis)',
            city: 'Ville (requis)',
            postalCode: 'Code postal (requis)',
            latitude: 'Latitude (optionnel)',
            longitude: 'Longitude (optionnel)',
            appartment: 'Appartement',
            comment: 'Commentaire livraison',
            timeToComplete: 'Temps à l\'arrêt en minutes (optionnel, une fois par visite)'
        },
        timeToComplete: 'Temps à l\'arrêt (minutes)',
        timeToCompleteHint: 'Laisser vide pour le temps par défaut. Sinon, minutes passées sur place, une fois par visite.',
        export: {
            success: 'Export réussi',
            filename: 'adresses.csv'
        },
        importSuccess: 'adresses importées avec succès',
        importAddressCityPostalRequired: 'L\'adresse, la ville et le code postal sont requis pour chaque ligne. Veuillez vous assurer que la colonne code postal est remplie.',
    },
    mapReport: {
        actions: {
            filter: 'Filtrer'
        },
        emptyState: 'Aucune commande trouvée pour cette période.'
    },
    clientPortal: {
        navbar: {
            help: 'Aide',
            helpIntro: 'Des questions?',
            helpCallLabel: 'Appelez-nous au',
            helpEmailLabel: 'ou écrivez-nous à :',
            languageMenu: 'Choisir la langue',
        },
        home: {
            title: 'Portail client',
            signIn: 'Se connecter',
            whatToday: 'Que souhaitez-vous faire aujourd\'hui?',
            hiring: 'Embauche',
            becomeDriver: 'Devenir chauffeur',
        },
        request: {
            destinationsQuestion: 'Combien de destinations?',
            singleDestination: 'Une seule destination',
            multiDestination: 'Plusieurs destinations',
            recurringQuestion: 'Vous avez des besoins récurrents?',
            chooseService: 'Choisissez un service',
            dedicatedDriver: 'Chauffeur dédié',
            dedicatedBlurb1: 'Livreur attitré à votre commerce, payé à l\'heure',
            dedicatedBlurb2: '+ économique si le volume de commandes peut être livré dans la même période de la journée / même région',
            dedicatedBlurb3: 'Nécessite un délai de 24 h afin d\'attribuer un chauffeur au quart de travail',
            payPerPiece: 'Payer à la pièce',
            payPerBlurb1: 'Le volume ne justifie pas un chauffeur dédié',
            payPerBlurb2: 'Les commandes doivent être livrées dans des régions différentes',
            payPerBlurb3: 'Les heures de ramassage/livraison sont flexibles',
            howManyParcels: 'Combien de colis?',
            singleShipment: '1 seul envoi',
            shuttleService: 'Service de navette',
            transferBetweenStores: 'Transfert entre magasin',
            etc: 'etc.',
            multipleParcels: 'Plusieurs colis',
            pageTitleMultiParcel: 'Nouvelle demande de service - Plusieurs colis',
            pageTitleOneTime: 'Nouvelle demande de service - 1 seule fois',
            pageTitleSingleShipment: 'Nouvelle demande de service - 1 seul envoi',
            merchantContactTitle: 'Coordonnées du commerce',
            scheduleTitle: 'Horaire',
            pickupAddressTitle: 'Adresse de ramassage',
            destinationTitle: 'Destination',
            next: 'Suivant',
            resetForm: 'Réinitialiser le formulaire',
            chooseAddressFromList: 'Veuillez choisir une adresse parmi la liste déroulante',
        },
        tracking: {
            enterTrackingNumber: 'Entrez votre numéro de suivi',
            enterReferenceNumber: 'Numéro de référence de la livraison',
            enterDestinationPostalCode: 'Code postal de destination',
            lookupError: 'Aucune commande trouvée pour cette référence et ce code postal.',
            track: 'Suivre',
            pageTitleDetail: 'Suivi de la commande',
        },
        register: {
            hubMerchantsTitle: 'Commerces/Expéditeurs',
            hubDriversTitle: 'Livreurs',
            signUp: 'Inscrivez-vous',
            merchantPageTitle: 'Inscription marchand',
            driverPageTitle: 'Inscription livreur',
            driverHeading: 'Inscription livreur',
            stepAccount: 'Compte',
            stepProfile: 'Profil',
            stepConfirmation: 'Confirmation',
            alreadyHaveAccount: 'Vous avez déjà un compte?',
            emergencyContactRequired: 'Veuillez indiquer un contact d\'urgence',
            emergencyPhoneRequired: 'Veuillez confirmer le numéro de téléphone du contact d\'urgence',
            vehicleModelRequired: 'Veuillez sélectionner un modèle de véhicule',
            driverLastNameRequired: 'Veuillez indiquer votre nom de famille',
        },
        mfOrder: {
            newRequestTitle: 'Nouvelle demande de transport',
            newRequestDocTitle: 'Nouvelle demande',
            pickup: 'Ramassage',
            destination: 'Destination',
            save: 'Enregistrer',
            noMerchantFound: 'Aucun commerce trouvé',
            poweredBy: 'Propulsé par',
        },
    },
    proofOfDelivery: {
        edit: 'Modifier',
        save: 'Enregistrer',
        cancel: 'Annuler',
        noPodYet: 'Aucune preuve de livraison. Vous pouvez en ajouter une.',
        noData: 'Aucune donnée disponible.',
        comment: 'Commentaire / Reçu par',
        deliveryDateTime: 'Date et heure de livraison',
        saveError: 'Erreur lors de l\'enregistrement de la preuve de livraison.',
        loading: 'Chargement...',
        deliveredAt: 'Livré à',
        receiveBy: 'Reçu par',
        commentOnly: 'Commentaire',
        receiveByAndComment: 'Reçu par / Commentaire',
        confirmedBoxes: 'Boîtes confirmées',
        receivedByPlaceholder: 'Reçu par',
        signature: 'Signature',
        receptionImage: 'Image de la réception',
        download: 'Télécharger',
        fetchError: 'Erreur lors du chargement de la preuve de livraison.',
        invalidDepositedPackageCount: 'Le nombre de boîtes doit être un entier entre 1 et {{max}}.',
    },
    orderTracking: {
        noOrderFound: 'Aucune commande n\'a été trouvée',
        deliveryDefault: 'Livraison',
        help: 'Aide',
        callMerchant: 'Appeler le commerce',
        callSupport: 'Appeler l\'assistance',
        refreshPage: 'Rafraîchir la page',
        mapUnavailable: 'Carte non disponible',
        deliveryDate: 'Date de livraison',
        viewProofOfDelivery: 'Consulter la preuve de livraison',
        estimatedDate: 'Date de livraison estimée',
        estimatedTime: 'Date et heure de livraison estimées',
        progressConfirmed: 'Confirmé',
        progressPickedUp: 'Cueillette',
        progressEnRoute: 'En route',
        progressDelivered: 'Livraison',
        yourDriver: 'Votre livreur(se)',
        contactDriver: 'Contacter le livreur',
        orderCancelled: 'Cette commande a été annulée',
        orderReturnedToMerchant: 'Cette commande a été retournée au marchand',
        statusHeading: 'Statut',
        orderReference: 'Numéro de référence de l\'envoi',
        deliveryAddress: 'Adresse de livraison',
        apartment: 'Appartement',
        comment: 'Commentaire',
        reviewPrompt: 'Comment avez-vous trouvé le service? Dites-le-nous!',
        leaveReview: 'Laisser un avis',
        poweredBy: 'Propulsé par',
        proofOfDeliveryTitle: 'Preuve de livraison',
        thirdPartyCarrierIntroStart: 'Cette livraison est assurée par ',
        thirdPartyCarrierIntroEnd: '. ',
        thirdPartyCarrierLink: 'Cliquez ici',
        thirdPartyCarrierAfterLink: ' pour ouvrir la page de suivi du transporteur.',
        status: {
            enAttente: 'En préparation, en attente d\'un livreur',
            assigne: 'La livraison est assignée à un itinéraire',
            enDirection: 'Le livreur est en direction pour le ramassage',
            arrive: 'Le livreur est arrivé au commerce',
            recupereeCarrier: 'En livraison par le transporteur',
            recuperee: 'Le livreur a récupéré la commande',
            enRoute: 'Le livreur est en route',
            livre: 'La commande a été livrée!',
            annule: 'La commande a été annulée',
            enRetour: 'Retour en cours vers le marchand',
            retour: 'La commande a été retournée au marchand',
            echec: 'La livraison n\'a pas pu être complétée',
            attention: 'Un problème est survenu avec la livraison',
            transitCarrier: 'En transit vers vous',
            transit: 'En transit',
            aConfirmer: 'La commande est reçue mais pas encore prête pour le ramassage',
            transitGeneric: 'En transit',
            waiting: 'En attente',
        },
    },
    procedureDocument: {
        pickupLabel: 'Procédure de cueillette',
        dropoffLabel: 'Procédure de livraison',
        upload: 'Téléverser un PDF',
        replace: 'Remplacer le PDF',
        remove: 'Retirer',
        view: 'Voir la procédure',
        deleteConfirm: 'Retirer cette procédure?',
        uploadFailed: 'Impossible de téléverser le PDF.',
        deleteFailed: 'Impossible de retirer la procédure.',
        viewFailed: 'Impossible d\'ouvrir la procédure.',
        invalidType: 'Veuillez sélectionner un fichier PDF.',
        sectionTitle: 'Procédures',
        openInNewTab: 'Ouvrir dans un nouvel onglet',
        addLink: 'Ajouter un lien',
        editLink: 'Modifier le lien',
        saveLink: 'Enregistrer le lien',
        linkPlaceholder: 'https://aide.exemple.com/article/...',
        linkRequired: 'Veuillez entrer une URL.',
        invalidLink: 'L\'URL doit commencer par http:// ou https://.',
        linkFailed: 'Impossible d\'enregistrer le lien.',
    },
    dedicatedLive: {
        title: 'Service attitré — live',
        date: 'Date',
        merchants: 'commerces',
        online: 'en ligne',
        activeOrders: 'livraisons actives',
        allMerchants: 'Tous les commerces',
        refresh: 'Actualiser',
        loading: 'Chargement…',
        empty: 'Aucun quart attitré pour cette date.',
        loadError: 'Impossible de charger la vue live attitrée.',
        backToList: 'Retour à la liste',
        shifts: 'Quarts',
        noShifts: 'Aucun quart',
        unassigned: 'Non assigné',
        onlineDrivers: 'Livreurs en ligne',
        noneOnline: 'Aucun livreur en ligne',
        offlineDrivers: 'hors ligne',
        noOrders: 'Aucune livraison active',
    },
    merchantSupport: {
        title: 'Support',
        intro: 'Guides, documentation et un moyen de joindre l\'équipe OnShip.',
        guides: 'Guides interactifs',
        guidesIntro: 'Choisissez un sujet, puis une tâche. Le guide met l\'écran en évidence au fur et à mesure.',
        back: 'Retour',
        topics: {
            orders: 'Livraisons',
            fleet: 'Livreurs et carte',
            settings: 'Paramètres',
        },
        useCases: {
            createOrder: 'Créer une livraison',
            importOrders: 'Importer des livraisons',
            trackingLink: 'Obtenir le lien de suivi',
            printLabel: 'Imprimer l\'étiquette',
            proofOfDelivery: 'Obtenir la preuve de livraison',
            findDelivery: 'Retrouver une livraison',
            mapControls: 'Contrôles de la carte',
            createRoute: 'Création de route',
            editRoute: 'Modifier une route',
            assignDriver: 'Assignation d\'un livreur',
            setDriverOnline: 'Mettre un livreur en ligne',
            search: 'Recherche',
            drivers: 'Livreurs',
            locations: 'Historique des positions',
            addresses: 'Adresses enregistrées',
            billing: 'Facturation',
            business: 'Informations du commerce',
            integrations: 'Intégrations',
            users: 'Utilisateurs',
            language: 'Langue',
            notifications: 'Préférences de courriel',
            password: 'Mot de passe',
        },
        copy: {
            createOrderMenuTitle: 'Livraisons',
            createOrderMenu: 'Les nouvelles livraisons partent de Livraisons, dans le menu.',
            createOrderAddTitle: 'Ajouter une livraison',
            createOrderAdd: 'Cliquez sur Ajouter une commande.',
            createOrderFormTitle: 'Formulaire',
            createOrderForm: 'Indiquez le ramassage, la destination et les colis, puis envoyez la livraison.',
            importMenuTitle: 'Importer',
            importMenu: 'Ouvrez le menu à côté de Ajouter une commande, puis choisissez Importer.',
            importFileTitle: 'Fichier',
            importFile: 'Téléversez votre fichier, associez les colonnes, vérifiez l\'aperçu, puis confirmez le ramassage.',
            trackingRowTitle: 'Ouvrir une livraison',
            trackingRow: 'Cliquez sur une livraison dans la liste.',
            trackingNeedOrder: 'Créez d\'abord une livraison. Le lien de suivi se trouve ensuite dans sa fiche.',
            trackingOpenTitle: 'Lien de suivi',
            trackingOpen: 'Ouvrez Lien de suivi.',
            trackingShareTitle: 'Partager',
            trackingShare: 'Copiez le lien ou envoyez-le par courriel.',
            printBulkTitle: 'Plusieurs étiquettes',
            printBulk: 'Sélectionnez des livraisons, puis choisissez le format d\'étiquette.',
            printRowTitle: 'Une livraison',
            printRow: 'Vous pouvez aussi imprimer depuis une seule livraison. Cliquez sur une ligne.',
            printNeedOrder: 'Quand vous avez une livraison, ouvrez-la pour imprimer son étiquette. Vous pouvez aussi en sélectionner plusieurs et utiliser ce menu d\'impression.',
            printSheetTitle: 'Étiquette',
            printSheet: 'Imprimez l\'étiquette d\'expédition depuis la fiche.',
            podMenuTitle: 'Historique',
            podMenu: 'La preuve de livraison se consulte dans Historique des commandes.',
            podActionsTitle: 'Actions de la ligne',
            podActions: 'Ouvrez le menu d\'actions d\'une commande livrée.',
            podNeedOrder: 'L\'historique est vide pour le moment. Après une livraison avec une preuve, le menu d\'actions de la ligne propose Preuve de livraison.',
            podItemTitle: 'Preuve de livraison',
            podItem: 'Choisissez Preuve de livraison. L\'option est offerte quand une preuve a été capturée.',
            findDeliverySearchMenuTitle: 'Recherche',
            findDeliverySearchMenu: 'Ouvrez Recherche dans le menu pour retrouver une livraison.',
            findDeliverySearchFieldTitle: 'Champ de recherche',
            findDeliverySearchField: 'Cherchez par numéro de référence, par adresse ou par nom du client. L\'adresse et le nom portent sur les 12 derniers mois.',
            findDeliveryHistoryMenuTitle: 'Historique',
            findDeliveryHistoryMenu: 'L\'historique liste les livraisons sur une période de dates.',
            findDeliveryFilterTitle: 'Filtrer',
            findDeliveryFilter: 'Par défaut, les livraisons prévues vont de 6 jours avant aujourd\'hui à 7 jours après. Cliquez sur Filtrer pour changer les dates de début et de fin.',
            mapControlsTitle: 'Contrôles de la carte',
            mapControls: 'Ces boutons changent ce que la carte affiche.',
            mapDriversTitle: 'Livreurs',
            mapDrivers: 'Affiche ou masque les livreurs.',
            mapOrdersTitle: 'Commandes',
            mapOrders: 'Affiche ou masque les commandes.',
            mapRoutesTitle: 'Routes',
            mapRoutes: 'Affiche ou masque les routes.',
            mapZoomTitle: 'Zoom',
            mapZoom: 'Zoomez ou dézoomez.',
            mapDrawTitle: 'Dessiner une zone',
            mapDraw: 'Tracez sur la carte pour sélectionner les commandes à l\'intérieur d\'une zone.',
            routeActionsTitle: 'Sélectionner des livraisons',
            routeActions: 'Sélectionnez les livraisons à regrouper, puis ouvrez le menu d\'actions.',
            routeCreateTitle: 'Créer une route',
            routeCreate: 'Choisissez Créer une route pour regrouper la sélection.',
            editRouteMenuTitle: 'Routes',
            editRouteMenu: 'Les routes se gèrent depuis Routes, dans le menu.',
            editRouteRowTitle: 'Choisir une route',
            editRouteRow: 'Ouvrez le menu d\'actions de la route à modifier.',
            editRouteNeedRoute: 'Créez d\'abord une route. Vous pourrez ensuite la modifier depuis cette liste.',
            editRouteActionTitle: 'Modifier',
            editRouteAction: 'Choisissez Modifier.',
            editRouteEditorTitle: 'Éditeur de route',
            editRouteEditor: 'Réordonnez les arrêts et ajustez la route, puis enregistrez.',
            driverOnlineMenuTitle: 'Livreurs',
            driverOnlineMenu: 'Les livreurs en ligne et hors-ligne se gèrent depuis Livreurs.',
            driverOnlineOfflineTitle: 'Livreurs hors-ligne',
            driverOnlineOffline: 'Ouvrez la liste des livreurs hors-ligne.',
            driverOnlineActionTitle: 'En ligne',
            driverOnlineAction: 'Ouvrez le menu du livreur, puis choisissez En ligne. Il pourra ensuite recevoir des livraisons.',
            driverOnlineNeedDriver: 'Ajoutez d\'abord un livreur, ou tous vos livreurs sont déjà en ligne. Le bouton En ligne se trouve dans le menu d\'un livreur hors-ligne.',
            assignActionsTitle: 'Sélectionner des livraisons',
            assignActions: 'Sélectionnez les livraisons, puis ouvrez le menu d\'actions.',
            assignChooseTitle: 'Assigner',
            assignChoose: 'Choisissez Assigner pour donner ces livraisons à un livreur. Vous pouvez aussi le faire depuis la fiche d\'une livraison.',
            searchLinkTitle: 'Recherche',
            searchLink: 'La recherche trouve les commandes, les adresses, les factures et, si vous avez des livreurs, les livreurs et les routes.',
            searchFieldTitle: 'Champ de recherche',
            searchField: 'Tapez au moins deux caractères.',
            driversTitle: 'Livreurs',
            drivers: 'Gérez les comptes livreurs de votre commerce.',
            locationsTitle: 'Historique des positions',
            locations: 'Consultez le parcours de vos livreurs.',
            addressesTitle: 'Adresses enregistrées',
            addresses: 'Conservez les destinations fréquentes pour les réutiliser dans une commande.',
            billingTitle: 'Facturation',
            billing: 'Factures, paiements et mode de paiement.',
            businessLinkTitle: 'Commerce',
            businessLink: 'Ouvrez la fiche de votre commerce.',
            businessFormTitle: 'Fiche du commerce',
            businessForm: 'Mettez à jour l\'adresse, le délai par défaut, les notifications et l\'exigence d\'une preuve de livraison.',
            integrationsTitle: 'Intégrations',
            integrations: 'Branchez un point de vente ou une autre source de commandes.',
            usersTitle: 'Utilisateurs',
            users: 'Ajoutez les personnes qui peuvent utiliser ce compte marchand.',
            languageTitle: 'Langue',
            language: 'Passez l\'interface du français à l\'anglais, ou l\'inverse.',
            notificationsTitle: 'Préférences de courriel',
            notifications: 'Choisissez les courriels que vous recevez.',
            passwordLinkTitle: 'Mot de passe',
            passwordLink: 'Ouvrez le formulaire du mot de passe.',
            passwordFormTitle: 'Nouveau mot de passe',
            passwordForm: 'Entrez le mot de passe actuel, puis le nouveau.',
        },
        documentation: 'Documentation',
        documentationIntro: 'Articles d\'aide et tutoriels',
        openDocumentation: 'Lien vers documentation',
        ticket: 'Billet de support',
        ticketIntro: 'Décrivez votre demande. Nous vous répondrons par courriel à : {{email}}',
        supportHours: 'Horaire du support : 9h à 20h tous les jours',
        avgResponseTime: 'Temps moyen de réponse : 10 minutes',
        subject: 'Sujet',
        message: 'Message',
        send: 'Envoyer',
        ticketSent: 'Votre demande a été envoyée. Nous vous répondrons sous peu.',
        ticketFailed: 'Impossible d\'envoyer votre demande. Veuillez réessayer.',
        contact: 'Coordonnées',
        openChat: 'Ouvrir le clavardage',
        tourNext: 'Suivant',
        tourPrev: 'Retour',
        tourDone: 'Terminer',
    },
};
